import React, { useState, useEffect, useMemo, useRef } from 'react';
import ImageLibrarySelectionModal from '../accounting/inventory/ImageLibrarySelectionModal';
import IconSelectionModal from './IconSelectionModal';
import { 
  Container, 
  Typography, 
  Paper, 
  Box, 
  Button, 
  CircularProgress, 
  Alert,
  styled,
  Grid,
  Card,
  CardContent,
  CardActions,
  Divider,
  Switch,
  FormControlLabel,
  Tabs,
  Tab,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Slider,
  TextField,
  InputAdornment
} from '@mui/material';
import { getHeaderConfig, saveHeaderConfig, getMenuConfig, saveMenuConfig, getMenuCategories, saveMenuCategory, reorderMenuCategories, getGeneralConfig, saveGeneralConfig, getSiteBackgrounds, getActiveSiteBackground, saveSiteBackground, getSliderSettings, getCategorySettings, normalizeCategorySettingsFromApi, saveCategorySettings, saveAboutSettings, getPublicCategoriesWithHierarchy } from '../../services/ecommerceApi';
import { buildCorporateHeroSavePayload } from '../../utils/corporateHeroSettings';
import { defaultCorporateHeroSectionSettings } from '../../types/corporateHero';
import EcommerceSaveToastHost from './components/EcommerceSaveToastHost';
import { notifyEcommerceSaved } from './utils/ecommerceSaveToast';
import {
  parseCorporateSidebarSettingsJson,
  serializeCorporateSidebarSettingsJson,
  resolveCorporateSidebarLayoutMode,
  serializeSectionSettingsJson,
  type CorporateSidebarSettings,
} from './utils/corporateSectionSettings';
import accountingService from '../../services/accountingService';
import type { BrandFlowSettings } from './components/brandFlow/types';
import type { ShowcaseSettings } from './components/showcase/types';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import StoreIcon from '@mui/icons-material/Store';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import CategoryIcon from '@mui/icons-material/Category';
import CollectionsIcon from '@mui/icons-material/Collections';
import SettingsIcon from '@mui/icons-material/Settings';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import StorefrontIcon from '@mui/icons-material/Storefront';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import ImageIcon from '@mui/icons-material/Image';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import FaceOutlinedIcon from '@mui/icons-material/FaceOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useNavigate } from 'react-router-dom';
import { updateCompanyInfo } from '../../services/migration/companyDataService';
import firebaseDataService from '../../services/FirebaseDataService';
import { storage } from '../../firebase';
import ownAuthSession from '../../services/auth/ownAuthSession';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useAuth } from '../../contexts/AuthContext';
import CategoryImageModal from './CategoryImageModal';
import ImageViewModal from '../accounting/inventory/components/ImageViewModal';
import ConfirmDialog from '../common/ConfirmDialog';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Grid3X3Icon from '@mui/icons-material/Grid3x3';
import SliderSettingsComponent from './components/SliderSettings';
import CategorySettingsComponent from './components/CategorySettings';
import ProductSettingsComponent from './components/ProductSettings';
import ProductDetailSettings from './components/ProductDetailSettings';
import ProductDetailSettings2 from './components/ProductDetailSettings2';
import LoginPageSettings from './components/LoginPageSettings';
import FooterSettingsComponent from './components/FooterSettings';
import MembersManagement from './components/MembersManagement';
import OrdersManagement from './components/OrdersManagement';
import ProductQuestionsManagement from './components/ProductQuestionsManagement';
import HomePageSettings from './components/HomePageSettings';
import ContentCardsSettings from './components/ContentCardsSettings';
import CartSettingsComponent from './components/CartSettingsComponent';
import ServiceSettingsComponent from './components/OurServicessettings';
import AboutSettingsComponent from './components/AboutSettingsComponent';
import PagesSettings from './components/PagesSettings';
import FormsSettings from './components/FormsSettings';
import LegalDocumentsSettings from './components/LegalDocumentsSettings';
import { useTranslation } from 'react-i18next';
import ContactSettingsComponent from './components/ContactSettingsComponent';
import BranchSettingsComponent from './components/BranchSettingsComponent';
import ReferencesSettingsComponent from './components/ReferencesSettingsComponent';
import BlogSettingsComponent from './components/BlogSettingsComponent';
import FAQSettingsComponent from './components/FAQSettingsComponent';
import ProductSolutionSettingsComponent from './components/ProductSolutionSettingsComponent';
import HeaderSettings from './components/HeaderSettings';
import { getHeaderTemplate, normalizeHeaderTypeId } from './utils/headerTemplates';
import { getHeaderSearchSaveFields } from './utils/headerSearchSettings';
import {
  HEADER_NAVBAR_EXTRAS_DEFAULTS,
  embedNavbarExtrasInMenuJson,
  resolveHeaderNavbarExtras,
  stripNavbarExtrasItem,
} from './utils/headerNavbarExtras';
import MenuSettings from './components/MenuSettings';
import GeneralSettings from './components/GeneralSettings';
import LanguageSettings from './components/LanguageSettings';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from '@mui/icons-material/Assignment';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import BuildIcon from '@mui/icons-material/Build';
import BusinessIcon from '@mui/icons-material/Business';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import EcommerceTabNavigation from './components/EcommerceTabNavigation';
import GuideButton from '../common/guide/GuideButton';
import ReviewsManagement from './components/ReviewsManagement';
import SupportManagement from './components/SupportManagement';
import LiveChatManagement from './components/LiveChatManagement';
import {
  OPEN_LIVE_CHAT_EVENT,
  consumeOpenLiveChatRequest,
  useChatAlerts,
} from '../../services/ecommerceChatAlerts';
import { DEFAULT_TAB_ID, EcommerceNavMode, EcommerceTabId } from './navigationConfig';
import { isAquaSoftBrand, readEcommerceNavMode, readSiteWizardEnabled, writeEcommerceNavMode, writeSiteWizardEnabled } from './utils/ecommerceNavMode';
import B2BManagement from './components/B2BManagement';
import MokaPaymentSettings from './components/MokaPaymentSettings';
import GuestCheckoutSettings from './components/GuestCheckoutSettings';
import SiteSetupWizard from './components/setupWizard/SiteSetupWizard';
import ReturnsManagement from './components/ReturnsManagement';
import CampaignManagement from './components/CampaignManagement';
import BrandManagement from './components/BrandManagement';
import MarketingPromoCards from './components/MarketingPromoCards';
import ShowcaseAreasManagement from './components/ShowcaseAreasManagement';

// Menü bileşenlerini import et (önizleme için)
// Not: Gerçek import'lar çalışma zamanında yüklenir
// import Menu1 from '../../../gts_ecommerce/src/components/menu/Menu1';
// import Menu2 from '../../../gts_ecommerce/src/components/menu/Menu2';
// import Menu3 from '../../../gts_ecommerce/src/components/menu/Menu3';

// Yeni arayüzler
export type DisplayStyle = 'grid' | 'list' | 'carousel' | 'modern-grid' | 'modern-list' | 'modern-carousel';

export interface TitleStyles {
  fontSize: number;
  color: string;
  bold: boolean;
  italic: boolean;
  fontFamily: string;
  textAlign: 'left' | 'center' | 'right';
}

export type {
  BrandFlowItem,
  BrandFlowSettings,
  BrandFlowTextStyles,
} from './components/brandFlow/types';

export interface ModuleSettings {
  enabled: boolean;
  displayStyle: {
    web: DisplayStyle;
    mobile: DisplayStyle;
  };
  titleStyles: TitleStyles;
  /** HTML Editör içeriği (sütun düzeni dahil) — Ürün & Çözümler ile aynı editör */
  htmlContent?: string;
  selectedProductIds: string[];
  selectedCategoryIds?: string[]; // Seçilen kategori ID'leri
  /** manual: panelden ürün seç; category: seçilen kategorinin ilk N ürünü */
  productSource?: 'manual' | 'category';
  moduleTemplate?: 'default' | 'category-row' | 'brand-flow' | 'showcase';
  /** Üründen bağımsız tam genişlik marka akışı ayarları */
  brandFlow?: BrandFlowSettings;
  /** Görselli veya görselsiz tanıtım bloğu */
  showcase?: ShowcaseSettings;
  showViewAllButton?: boolean;
  viewAllButtonText?: string;
  categoryProductLimit?: number;
  maxProducts: number;
  maxCategories?: number; // Maksimum kategori sayısı
  itemsPerRow: number;
  horizontalPosition?: number; // 0-100 arası yatay konum
  topSpacing?: number; // Modülün ana sayfadaki üst boşluğu (px)
  moduleImage?: {
    imageUrl: string;
    imageUrl2?: string; // İkinci resim opsiyonel
    imageUrl3?: string; // Üçüncü resim opsiyonel
    imageUrl4?: string; // Dördüncü resim opsiyonel
    imageUrl5?: string; // Beşinci resim opsiyonel
    imageUrl6?: string; // Altıncı resim opsiyonel
    imageUrl7?: string; // Yedinci resim opsiyonel
    imageUrl8?: string; // Sekizinci resim opsiyonel
    imageUrl9?: string; // Dokuzuncu resim opsiyonel
    imageUrl10?: string;
    imageUrl11?: string;
    imageUrl12?: string;
    imageUrl13?: string;
    imageUrl14?: string;
    imageUrl15?: string;
    imageUrl16?: string;
    width: number;
    height: number;
    renderScale?: number; // Sayfada gorunum olcegi (%)
    mobileRenderScale?: number; // Mobilde gorunum olcegi (%)
    alignment: 'left' | 'center' | 'right';
    linkUrl?: string; // Eski sistem uyumluluğu için
    // Yeni resim başlık ve link sistemi
    imageTitles?: {
      title1?: string;
      title2?: string;
      title3?: string;
      title4?: string;
      title5?: string;
      title6?: string;
      title7?: string;
      title8?: string;
      title9?: string;
      title10?: string;
      title11?: string;
      title12?: string;
      title13?: string;
      title14?: string;
      title15?: string;
      title16?: string;
    };
    imageLinks?: {
      link1?: string;
      link2?: string;
      link3?: string;
      link4?: string;
      link5?: string;
      link6?: string;
      link7?: string;
      link8?: string;
      link9?: string;
      link10?: string;
      link11?: string;
      link12?: string;
      link13?: string;
      link14?: string;
      link15?: string;
      link16?: string;
    };
    titleStyles?: {
      fontSize: number;
      color: string;
      bold: boolean;
      italic: boolean;
      fontFamily: string;
      position: 'top' | 'bottom'; // Başlık pozisyonu
    };
    imageGap?: {
      horizontal: number;
      vertical: number;
    };
    imageSeparatorH?: {
      style: 'none' | 'solid' | 'dashed' | 'dotted';
      color: string;
      width: number;
    };
    imageSeparatorV?: {
      style: 'none' | 'solid' | 'dashed' | 'dotted';
      color: string;
      width: number;
    };
    moduleDisplayMode?: 'grid' | 'slider';
    moduleSliderAutoplay?: boolean;
    moduleSliderInterval?: number;
    moduleSliderShowArrows?: boolean;
    moduleSliderLoop?: boolean;
    moduleSliderPauseOnHover?: boolean;
    moduleSliderVisibleCount?: number;
    pageSidePadding?: number;
    productLayout?: {
      rows: number;
      columns: number;
    };
    productCardSize?: {
      width: number;
      height: number;
    };
    productCardStyle?: {
      cardEnabled?: boolean;
      showProductName?: boolean;
      showPrice?: boolean;
      showOldPrice?: boolean;
      brandTabsEnabled?: boolean;
      categoryTabsEnabled?: boolean;
      productGrid?: {
        alignment?: 'left' | 'center' | 'right';
        horizontalGap?: number;
        verticalGap?: number;
      };
      displayMode?: 'grid' | 'slider';
      sliderAutoplay?: boolean;
      sliderInterval?: number;
      sliderShowArrows?: boolean;
      sliderLoop?: boolean;
      sliderPauseOnHover?: boolean;
      sliderVisibleCount?: number;
      productNameColor?: string;
      productNameFontSize?: number;
      productNameBold?: boolean;
      productNameItalic?: boolean;
      priceColor?: string;
      priceFontSize?: number;
      priceBold?: boolean;
      priceItalic?: boolean;
    };
  };
  productCardStyle?: { // YENİ ALAN: Ürün kartı stilleri
    size: { width: number; height: number };
    imageHeight: number;
    cardSettings: {
      showProductName: boolean;
      showSku: boolean;
      showPrice: boolean;
      showStockStatus: boolean;
      showAddToCartButton: boolean;
      /** 0 = kapalı; stok bu değerin altına (dahil) düşünce "Tükenmek üzere" */
      lowStockThreshold?: number;
      /** true: müşteriye kalan stok uyarısı göster. Varsayılan kapalı. */
      lowStockWarning?: boolean;
    };
    elementStyles: {
      productName: { fontSize: string; fontWeight: number; color: string; fontStyle: string; fontFamily: string };
      sku: { fontSize: string; fontWeight: number; color: string; fontStyle: string; fontFamily: string };
      price: { fontSize: string; fontWeight: string; color: string; fontStyle: string; fontFamily: string };
      stockStatus: { fontSize: string; fontWeight: number; color: string; fontStyle: string; fontFamily: string };
    };
    imageNavigationStyle: 'numbered' | 'circle' | 'dot';
  };
}

export interface CustomModule {
  id: string;
  tabName: string;
  sectionTitle: string;
  settings: ModuleSettings;
  order: number;
}

// Kategori tipi
interface Category {
  id: string;
  name: string;
  parentId: string | null;
  level: number;
  isEcommerceEnabled: boolean;
  order?: number;
}

// Menü kategorisi tipi
interface MenuCategory {
  id: string;
  name: string;
  visible: boolean;
  order: number;
  imageUrl?: string; // Kategori resmi URL'i
  headerImageUrl?: string; // Sayfa üst resmi URL'i
  subCategories?: MenuCategory[]; // Alt kategoriler
}

// Site Yapılandırması Tipi
interface EcommerceConfig {
  id?: string; // EcommerceConfig ID (SQL)
  headerSettings: {
    enabled: boolean; // Header'ı tamamen aç/kapat
    showLogo: boolean;
    showSearch: boolean;
    showCart: boolean;
    showUserMenu: boolean;
    showUserIcon: boolean; // Kullanıcı ikonunu göster/gizle
    showMobileCategories: boolean; // Mobil menüde kategoriler butonunu göster/gizle
    showBecomeSellerButton: boolean; // "Bizimle Satıcı Ol" butonunu göster/gizle
    showBottomNavbar?: boolean; // Mobil alt gezinme çubuğunu göster/gizle
    showHeaderInfoStrip?: boolean;
    headerInfoStripText?: string;
    headerInfoStripBackgroundColor?: string;
    headerInfoStripTextColor?: string;
    showHeaderMarqueeStrip?: boolean;
    headerMarqueeStripText?: string;
    headerMarqueeStripBackgroundColor?: string;
    headerMarqueeStripTextColor?: string;
    headerMarqueeSpeedSeconds?: number;
    backgroundColor: string;
    textColor: string;
    headerType: 'header1' | 'header2' | 'header3' | 'header4' | 'header5' | 'header6' | 'header7'; // Header tipi seçeneği
    logoUrl?: string; // ✅ Logo URL
    logoWidth?: number; // Logo genişliği ayarı
    logoHeight?: number; // Logo yüksekliği ayarı
    logoAlign?: 'left' | 'center' | 'right' | number | string; // Logo yatay konumu: eski enum değerleri ya da 0-100 yüzde
    mobileLogoUrl?: string; // ✅ Mobil logo URL
    favoriteIcon?: string;
    cartIcon?: string;
    userIcon?: string;
    iconSize?: number;
    verticalPadding?: number; // Header dikey boşluk (px)
    searchType?: 'product' | 'content' | 'none'; // Arama tipi seçeneği
    // Header4 özel kartları
    header4CategoryBackgroundColor?: string;
    header4CategoryTextColor?: string;
    header4CategoryIcon?: string;
    header4CategoryText?: string;
    header4CorporateIcon?: string;
    header4Cards?: {
      card1: {
        enabled: boolean;
        text: string;
        backgroundColor: string;
        textColor: string;
        iconUrl?: string;
        linkUrl?: string;
      };
      card2: {
        enabled: boolean;
        text: string;
        backgroundColor: string;
        textColor: string;
        iconUrl?: string;
        linkUrl?: string;
      };
    };
    // Header6 (Restoran/Brand) özel ayarları
    enableCustomNavMenu?: boolean;
    customNavMenu?: Array<{
      id: string;
      label: string;
      url: string;
      order: number;
      enabled: boolean;
      openInNewTab?: boolean;
      children?: Array<{
        id: string;
        label: string;
        url: string;
        order: number;
        enabled: boolean;
        openInNewTab?: boolean;
      }>;
    }>;
    orderButtonIcon?: string;
    orderButtonText?: string;
    orderButtonUrl?: string;
    orderButtonBackgroundColor?: string;
    orderButtonTextColor?: string;
    showOrderButton?: boolean;
    header6AdvancedStyleEnabled?: boolean;
    header6LogoAlign?: 'left' | 'center' | 'right';
    header6MenuFontSize?: number;
    header6MenuFontWeight?: number;
    header6MenuTextTransform?: 'none' | 'uppercase' | 'lowercase' | 'capitalize';
    header6MenuItalic?: boolean;
    header6MenuFontFamily?: string;
    header6MenuItemColor?: string;
    header6MenuLetterSpacing?: number;
    menuAlign?: 'left' | 'center' | 'right';
    showPhoneButton?: boolean;
    phoneText?: string;
    phoneUrl?: string;
    showBranchesButton?: boolean;
    branchesText?: string;
    branchesUrl?: string;
    contactButtonBackgroundColor?: string;
    contactButtonTextColor?: string;
    actionIconStyle?: 'plain' | 'circle';
    actionIconBackgroundColor?: string;
    actionIconColor?: string;
    enableHeaderBlur?: boolean;
    headerBlurAmount?: number;
    customNavMenuKind?: 'category' | 'corporate' | 'both' | '';
    advantagesDropdownJson?: string;
    taxCalculatorJson?: string;
    mealCardPageJson?: string;
  };
  menuSettings: {
    enabled: boolean;
    menuType: 'menu1' | 'menu2' | 'menu3'; // Menü tipi seçeneği
    menuPosition: 'left' | 'center' | 'right';
    verticalPadding?: number; // Menü dikey boşluk (px)
    backgroundColor?: string;
    textColor?: string;
    textTransform?: 'none' | 'uppercase' | 'lowercase' | 'capitalize'; // Yazı büyük/küçük harf ayarı
    directCategoryLinks?: boolean;
    menuItemSource?: 'categories' | 'brands';
    // Menü 3 özel ayarları
    showAllCategories?: boolean; // "Tüm Kategoriler" butonunu göster/gizle
    showHomePage?: boolean; // "Ana Sayfa" butonunu göster/gizle
    corporateNavDisplayMode?: 'panel' | 'dropdown';
    corporateSidebarLayoutMode?: 'below_hero' | 'below_navbar';
    corporateSidebarSettings?: CorporateSidebarSettings;
    showQuoteButton?: boolean; // "Teklif Al" CTA butonu
    quoteButtonTitle?: string;
    quoteButtonSubtitle?: string;
    quoteButtonLink?: string;
    showMenuLeftLogo?: boolean; // Menü solunda logo göster
    menuStyle?: 'menu1' | 'menu2' | 'menu3'; // Menü stili seçeneği
    moduleType?: 'module1' | 'module2'; // Ana sayfa modül stili seçeneği
  };
  menuCategories: MenuCategory[];
  sliderSettings: {
    enabled: boolean;
    autoplay: boolean;
    interval: number;
    slides: SlideItem[];
    height?: {
      web: number;
      mobile: number;
    };
  };
  categorySettings: {
    showOnHomepage: boolean;
    showOnProductsPage?: boolean;
    enableProductPicker?: boolean;
    targetPage?: string;
    insertAfter?: string;
    displayStyle: {
      web: 'grid' | 'list' | 'carousel' | 'modern-grid' | 'modern-list' | 'modern-carousel';
      mobile: 'grid' | 'list' | 'carousel' | 'modern-grid' | 'modern-list' | 'modern-carousel';
    };
    itemsPerRow: number;
    titleStyles: {
      fontSize: number;
      color: string;
      bold: boolean;
      italic: boolean;
      fontFamily: string;
      strokeWidth: number;
      strokeColor: string;
    };
    title?: string;
    menuDropdownEnabled?: boolean;
    menuDropdownStyle?: 'list' | 'minimal' | 'classic';
    menuDropdownColumns?: number;
    menuDropdownMaxHeight?: number;
  };
  productSettings: {
    displayStyle: 'grid' | 'list';
    itemsPerRow: number;
    showRatings: boolean;
    enableQuickView: boolean;
    enableWishlist: boolean;
    hideOutOfStock: boolean;
    hideProductsWithoutImage: boolean;
    customModules?: CustomModule[];
  };
  productDisplaySettings: {
    hideOutOfStock: boolean;
    hideProductsWithoutImage: boolean;
    productCardStyle?: any; // Eklendi
    customModules: Array<{
      id: string;
      tabName: string;
      sectionTitle: string;
    }>;
  };
  footerSettings: {
    showSocialLinks: boolean;
    showPaymentMethods: boolean;
    showNewsletter: boolean;
    backgroundColor: string;
    textColor: string;
    itemsPerRow: 4;
    showRatings: true;
    enableQuickView: true;
    enableWishlist: true;
  };
  // Yeni eklenen ayarlar
  aboutSettings?: any;
  serviceSettings?: any;
  contactSettings?: any;
  restaurantsSettings?: any;
  referencesSettings?: any;
  faqSettings?: any;
  cartSettings?: any;
  productSolutionSettings?: any;
  footerSettingsDetailed?: any;
  siteName?: string;
  metaTitle?: string;
  metaDescription?: string;
  metaKeywords?: string;
  // Site arka plan ayarları
  siteBackgroundSettings: {
    type: 'color' | 'pattern';
    backgroundColor: string;
    patternType: string | null;
  };
}

// Slider için slayt öğesi
interface SlideItem {
  id: string;
  mediaUrl: string;
  mediaType: 'image' | 'video';
  title: string;
  active: boolean;
  mediaPath?: string;
  overrideTitle?: any;
  overrideDescription?: any;
  overrideTextPosition?: string;
  overrideTextAlign?: 'left' | 'center' | 'right';
  overrideTextAnimation?: string;
  overlayArea?: 'full' | 'left' | 'center' | 'right';
  mobileMediaUrl?: string;
  mobileMediaPath?: string;
  buttons?: Array<{
    show?: boolean;
    label?: string;
    action?: 'scroll-to-section' | 'external-url' | 'contact-page' | 'products-page' | 'open-form' | 'none';
    target?: string;
    style?: 'primary' | 'secondary' | 'outline' | 'custom';
    formSlug?: string;
    formTitle?: string;
    templateId?: string;
    size?: 'sm' | 'md' | 'lg';
    placement?: string;
    backgroundColor?: string;
    textColor?: string;
    borderColor?: string;
    borderRadius?: 'md' | 'full';
  }>;
  button?: {
    show?: boolean;
    label?: string;
    action?: 'scroll-to-section' | 'external-url' | 'contact-page' | 'products-page' | 'open-form' | 'none';
    target?: string;
    style?: 'primary' | 'secondary' | 'outline' | 'custom';
    formSlug?: string;
    formTitle?: string;
    templateId?: string;
    size?: 'sm' | 'md' | 'lg';
    placement?: string;
    backgroundColor?: string;
    textColor?: string;
    borderColor?: string;
    borderRadius?: 'md' | 'full';
  };
}

type HeaderNavItem = NonNullable<EcommerceConfig['headerSettings']['customNavMenu']>[number];

const normalizeCustomNavItem = (item: any, fallbackIndex: number): HeaderNavItem => {
  const rawChildren = Array.isArray(item?.children) ? item.children : [];
  const children = rawChildren
    .map((child: any, idx: number) => normalizeCustomNavItem(child, idx))
    .sort((a: HeaderNavItem, b: HeaderNavItem) => Number(a.order ?? 0) - Number(b.order ?? 0))
    .map((child: HeaderNavItem, idx: number) => ({ ...child, order: idx }));

  return {
    id: String(item?.id || `nav_${fallbackIndex}_${Date.now()}`),
    label: String(item?.label || ''),
    url: String(item?.url || '/'),
    order: Number.isFinite(Number(item?.order)) ? Number(item.order) : fallbackIndex,
    enabled: item?.enabled !== false,
    openInNewTab: item?.openInNewTab === true,
    children,
  };
};

const normalizeCustomNavMenu = (items: any[]): HeaderNavItem[] =>
  items
    .map((item, index) => normalizeCustomNavItem(item, index))
    .sort((a, b) => Number(a.order ?? 0) - Number(b.order ?? 0))
    .map((item, index) => ({ ...item, order: index }));

// Yeni hesaplar ve toggle ilk açıldığında üst menüye otomatik gelecek sayfalar.
// Aynı sayfalar PagePickerDialog'daki "Hazır Sayfa" listesiyle uyumludur.
const createDefaultTopNavMenu = (): HeaderNavItem[] => {
  const stamp = Date.now();
  const make = (label: string, url: string, order: number): HeaderNavItem => ({
    id: `nav_default_${order}_${stamp}_${Math.random().toString(36).slice(2, 6)}`,
    label,
    url,
    order,
    enabled: true,
    children: [],
  });
  return [
    make('ANASAYFA', '/', 0),
    make('ÜRÜNLER', '/products', 1),
    make('HAKKIMIZDA', '/about', 2),
    make('HİZMETLER', '/services', 3),
    make('ÜRÜN & ÇÖZÜMLER', '/products-solutions', 4),
    make('İLETİŞİM', '/contact', 5),
  ];
};

const normalizeHeaderType = normalizeHeaderTypeId;

// Varsayılan yapılandırma
const defaultConfig: EcommerceConfig = {
  headerSettings: {
    enabled: true, // Varsayılan: header açık
    showLogo: true,
    showSearch: true,
    showCart: true,
    showUserMenu: true,
    showUserIcon: true, // Varsayılan: kullanıcı ikonu açık
    showMobileCategories: true, // Varsayılan: mobil kategoriler açık
    showBecomeSellerButton: false, // Varsayılan: "Bizimle Satıcı Ol" butonu kapalı
    showBottomNavbar: true, // Varsayılan: mobil alt navbar açık
    showHeaderInfoStrip: false,
    headerInfoStripText: 'KALİTELİ ÜRÜNLER VE AVANTAJLI FIRSATLAR SİZİ BEKLİYOR',
    headerInfoStripBackgroundColor: '#7ED957',
    headerInfoStripTextColor: '#111111',
    showHeaderMarqueeStrip: false,
    headerMarqueeStripText: 'ÖZEL KAMPANYALAR VE FIRSATLAR SİZİ BEKLİYOR',
    headerMarqueeStripBackgroundColor: '#0f172a',
    headerMarqueeStripTextColor: '#ffffff',
    headerMarqueeSpeedSeconds: 18,
    backgroundColor: '#ffffff',
    textColor: '#212121',
    headerType: 'header1', // Varsayılan header tipi
    logoWidth: 120, // Varsayılan logo genişliği
    logoHeight: 50, // Varsayılan logo yüksekliği
    logoAlign: 'left', // Varsayılan logo hizası
    favoriteIcon: 'favorite-1',
    cartIcon: 'cart-1',
    userIcon: 'user-1',
    iconSize: 24,
    verticalPadding: 16, // Varsayılan dikey boşluk 16px (py-4 gibi)
    searchType: 'product', // Varsayılan arama tipi
    // Header4 özel kartları varsayılan değerleri
    header4Cards: {
      card1: {
        enabled: true,
        text: 'Sipariş Hattı\n+90 444 61 62',
        backgroundColor: '#ff8c00',
        textColor: '#ffffff',
        iconUrl: 'phone', // İkon tipi (phone, headset, support, call, contact)
        linkUrl: 'tel:+904446162'
      },
      card2: {
        enabled: true,
        text: 'Online\nSipariş Ver',
        backgroundColor: '#dc2626',
        textColor: '#ffffff',
        iconUrl: 'cart', // İkon tipi (cart, bag, basket, mall, store)
        linkUrl: '/cart'
      }
    },
    // Header6 (Restoran/Brand) varsayilan ayarlari — diger header'larda kapali.
    // Toggle kapalı başlasın ama içerideki menü öğeleri default olarak dolu gelsin.
    enableCustomNavMenu: false,
    customNavMenu: createDefaultTopNavMenu(),
    orderButtonIcon: 'order-1',
    orderButtonText: 'SİPARİŞ VER',
    orderButtonUrl: '/cart',
    orderButtonBackgroundColor: '#e63946',
    orderButtonTextColor: '#ffffff',
    showOrderButton: false,
    header6AdvancedStyleEnabled: false,
    header6LogoAlign: 'left',
    header6MenuFontSize: 14,
    header6MenuFontWeight: 700,
    header6MenuTextTransform: 'uppercase',
    header6MenuItalic: false,
    header6MenuFontFamily: 'Inter, sans-serif',
    header6MenuItemColor: '#ffffff',
    header6MenuLetterSpacing: 0.6,
    ...HEADER_NAVBAR_EXTRAS_DEFAULTS,
  },
  menuSettings: {
    enabled: true,
    menuType: 'menu1',
    menuPosition: 'center',
    verticalPadding: 12, // Varsayılan dikey boşluk 12px (py-3 gibi)
    backgroundColor: '#ffffff',
    textColor: '#111827',
    textTransform: 'none', // Varsayılan: normal yazı
    directCategoryLinks: false,
    menuItemSource: 'categories',
    // Menü 3 özel ayarları
    showAllCategories: true, // Varsayılan: "Tüm Kategoriler" butonu açık
    showHomePage: true, // Varsayılan: "Ana Sayfa" butonu açık
    corporateNavDisplayMode: 'dropdown',
    corporateSidebarLayoutMode: 'below_hero',
    showQuoteButton: false,
    quoteButtonTitle: 'Teklif Al',
    quoteButtonSubtitle: 'Hemen arayın, size özel teklif hazırlayalım',
    quoteButtonLink: '/contact',
    showMenuLeftLogo: false,
    menuStyle: 'menu1', // Varsayılan menü stili
    moduleType: 'module1', // Varsayılan ana sayfa modül stili
  },
  menuCategories: [],
  sliderSettings: {
    enabled: true,
    autoplay: true,
    interval: 5000,
    slides: [],
    height: {
      web: 60, // Varsayılan web yüksekliği (vh)
      mobile: 40 // Varsayılan mobil yüksekliği (vh)
    }
  },
  categorySettings: {
    showOnHomepage: true,
    showOnProductsPage: false,
    enableProductPicker: false,
    targetPage: 'homepage',
    insertAfter: 'after-trust',
    displayStyle: {
      web: 'grid',
      mobile: 'list', // Mobil için varsayılan olarak liste görünümü
    },
    itemsPerRow: 4,
    titleStyles: {
      fontSize: 16,
      color: '#ffffff',
      bold: true,
      italic: false,
      fontFamily: 'Inter',
      strokeWidth: 0,
      strokeColor: '#000000',
    },
    title: 'Kategoriler',
    menuDropdownEnabled: true,
    menuDropdownStyle: 'minimal',
    menuDropdownColumns: 4,
    menuDropdownMaxHeight: 400,
  },
  productSettings: {
    displayStyle: 'grid',
    itemsPerRow: 4,
    showRatings: true,
    enableQuickView: true,
    enableWishlist: true,
    hideOutOfStock: false, // Varsayılan değer eklendi
    hideProductsWithoutImage: false, // Varsayılan değer eklendi
    customModules: [], // Özel modüller için varsayılan boş dizi
  },
  productDisplaySettings: {
    hideOutOfStock: false,
    hideProductsWithoutImage: false,
    productCardStyle: {}, // Varsayılan boş nesne eklendi
    customModules: [], // Özel modüller için varsayılan boş dizi
  },
  footerSettings: {
    showSocialLinks: true,
    showPaymentMethods: true,
    showNewsletter: true,
    backgroundColor: '#f5f5f5',
    textColor: '#212121',
    itemsPerRow: 4,
    showRatings: true,
    enableQuickView: true,
    enableWishlist: true
  },
  // Yeni eklenen ayarlar için default değerler
  aboutSettings: null,
  serviceSettings: null,
  contactSettings: null,
  restaurantsSettings: null,
  referencesSettings: null,
  faqSettings: null,
  cartSettings: null,
  productSolutionSettings: null,
  footerSettingsDetailed: null,
  siteName: '',
  metaTitle: '',
  metaDescription: '',
  metaKeywords: '',
  // Site arka plan ayarları için default değerler
  siteBackgroundSettings: {
    type: 'color' as const,
    backgroundColor: '#ffffff',
    patternType: null
  }
};

// Stiller
const ScrollableContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(3),
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  '& .MuiSvgIcon-root': {
    marginRight: theme.spacing(1),
  }
}));

const ECommercePage: React.FC = () => {
  const { userDetails } = useAuth();
  const { t } = useTranslation('salesSystem');
  const navigate = useNavigate();
  const [activeTabId, setActiveTabId] = useState<EcommerceTabId>(DEFAULT_TAB_ID);
  // Canlı destek uyarıları header'daki zilde global çalışır; burada yalnızca sayı okunur.
  const chatAlerts = useChatAlerts().count;
  const [liveChatFocus, setLiveChatFocus] = useState<{ sessionId: string | null; nonce: number } | null>(null);

  // Zil / toast / masaüstü bildiriminden "görüşmeyi aç" isteği.
  useEffect(() => {
    const open = (sessionId: string | null) => {
      setActiveTabId('liveChat');
      setLiveChatFocus({ sessionId, nonce: Date.now() });
    };
    const pending = consumeOpenLiveChatRequest();
    if (pending) open(pending.sessionId);
    const handler = (e: Event) => {
      consumeOpenLiveChatRequest();
      open((e as CustomEvent<{ sessionId: string | null }>).detail?.sessionId ?? null);
    };
    window.addEventListener(OPEN_LIVE_CHAT_EVENT, handler);
    return () => window.removeEventListener(OPEN_LIVE_CHAT_EVENT, handler);
  }, []);
  const [navMode, setNavMode] = useState<EcommerceNavMode>(() => readEcommerceNavMode());
  const [siteWizardEnabled, setSiteWizardEnabled] = useState(() => readSiteWizardEnabled());
  const showNavModeToggle = isAquaSoftBrand();

  const handleNavModeChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const next: EcommerceNavMode = checked ? 'classic' : 'compact';
    setNavMode(next);
    writeEcommerceNavMode(next);
  };

  const handleSiteWizardToggle = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setSiteWizardEnabled(checked);
    writeSiteWizardEnabled(checked);
    if (!checked && activeTabId === 'site-wizard') {
      setActiveTabId(DEFAULT_TAB_ID);
    }
  };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [companyId, setCompanyId] = useState<string | null>(null);
  const [config, setConfig] = useState<EcommerceConfig>(defaultConfig);
  const [isSaving, setIsSaving] = useState(false);
  const [currentLogoUrl, setCurrentLogoUrl] = useState<string | null>(null);
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);
  const [categoryImageModalOpen, setCategoryImageModalOpen] = useState(false);
  const [currentCategoryId, setCurrentCategoryId] = useState<string | null>(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [imageUploadType, setImageUploadType] = useState<'category' | 'header'>('category');
  const [expandedCategories, setExpandedCategories] = useState<Record<string, boolean>>({});
  const [faviconFile, setFaviconFile] = useState<File | null>(null);
  const [faviconPreview, setFaviconPreview] = useState<string | null>(null);
  const [isUploadingFavicon, setIsUploadingFavicon] = useState(false);
  const [currentFaviconUrl, setCurrentFaviconUrl] = useState<string | null>(null);
  
  // Site Background Settings (SQL)
  const [siteBackgroundSettings, setSiteBackgroundSettings] = useState<any>({
    type: 'color',
    backgroundColor: '#ffffff',
    patternType: null
  });
  const [backgroundConfigId, setBackgroundConfigId] = useState<string | null>(null);
  const [ecommerceConfigId, setEcommerceConfigId] = useState<string | null>(null);
  
  // SQL'den gelen header config
  const [sqlHeaderConfig, setSqlHeaderConfig] = useState<any>(null);
  const [loadingHeaderConfig, setLoadingHeaderConfig] = useState(false);
  const [headerConfigId, setHeaderConfigId] = useState<string | null>(null);
  
  // SQL'den gelen menu config
  const [sqlMenuConfig, setSqlMenuConfig] = useState<any>(null);
  const [loadingMenuConfig, setLoadingMenuConfig] = useState(false);
  const [menuConfigId, setMenuConfigId] = useState<string | null>(null);
  const menuConfigIdRef = useRef<string | null>(null);
  const ecommerceConfigIdRef = useRef<string | null>(null);
  
  // SQL'den gelen menu kategorileri
  const [sqlMenuCategories, setSqlMenuCategories] = useState<any[]>([]);
  const [loadingMenuCategories, setLoadingMenuCategories] = useState(false);
  const enrichMenuCategoriesWithInventoryHierarchy = async (menuCategories: any[]) => {
    try {
      // Ecommerce API'nin kendi public/categories endpoint'inden hiyerarşi al
      // Bu endpoint CategoriesController'dan gelir ve parentId + level içerir
      const publicCategories = companyId ? await getPublicCategoriesWithHierarchy(companyId) : [];

      // Eğer ecommerce API başarısız olursa accounting API'den dene (fallback)
      let hierarchySource = publicCategories;
      if (!hierarchySource || hierarchySource.length === 0) {
        try {
          const inventoryCategories = await accountingService.getCategories(false);
          hierarchySource = inventoryCategories || [];
        } catch { /* ignore */ }
      }

      // ID'leri lowercase string'e normalize ederek map oluştur
      const hierarchyMap = new Map<string, any>();
      (hierarchySource || []).forEach((category: any) => {
        // camelCase (ecommerce API) ve PascalCase (accounting API) her ikisini destekle
        const id = category?.id ?? category?.Id;
        if (id) {
          hierarchyMap.set(String(id).toLowerCase(), category);
        }
      });

      return (menuCategories || []).map((menuCategory: any) => {
        const lookupKey = String(menuCategory.categoryId ?? '').toLowerCase();
        const match = lookupKey ? hierarchyMap.get(lookupKey) : undefined;

        // camelCase ve PascalCase her ikisini de dene
        const matchParentId = match?.parentId ?? match?.ParentId ?? null;
        const matchLevel = match?.level ?? match?.Level ?? null;
        const matchName = match?.name ?? match?.Name;

        return {
          ...menuCategory,
          parentId: menuCategory.parentId ?? matchParentId,
          level: Number(menuCategory.level ?? matchLevel ?? 0),
          categoryName: menuCategory.categoryName || matchName || menuCategory.categoryId
        };
      });
    } catch {
      return menuCategories || [];
    }
  };
  const isNullParent = (parentId: any) => {
    const p = String(parentId ?? '').trim().toLowerCase();
    return !p || p === 'null' || p === 'undefined' || p === '00000000-0000-0000-0000-000000000000';
  };

  const mainMenuCategories = useMemo(() => {
    return (sqlMenuCategories || []).filter((category: any) => isNullParent(category?.parentId));
  }, [sqlMenuCategories]);

  const subMenuCategories = useMemo(() => {
    return (sqlMenuCategories || []).filter((category: any) => !isNullParent(category?.parentId));
  }, [sqlMenuCategories]);
  
  // Kategori resim seçimi için state'ler
  const [isCategoryImageModalOpen, setIsCategoryImageModalOpen] = useState(false);
  const [selectedCategoryForImage, setSelectedCategoryForImage] = useState<{categoryId: string, imageType: 'category' | 'banner'} | null>(null);
  // Kategori resmi büyük görüntüleme modalı
  const [categoryImageView, setCategoryImageView] = useState<{ url: string; name: string } | null>(null);
  // Kategori resmi kaldırma onayı
  const [categoryImageRemoveTarget, setCategoryImageRemoveTarget] = useState<{ categoryId: string; imageType: 'category' | 'banner'; name: string } | null>(null);
  const [isRemovingCategoryImage, setIsRemovingCategoryImage] = useState(false);
  
  // Otomatik kayıt için debounce timer'ları
  const headerSaveTimerRef = useRef<NodeJS.Timeout | null>(null);
  const headerLocalEditGenRef = useRef(0);
  const menuSaveTimerRef = useRef<NodeJS.Timeout | null>(null);
  const aboutSaveTimerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    menuConfigIdRef.current = menuConfigId;
  }, [menuConfigId]);

  useEffect(() => {
    ecommerceConfigIdRef.current = ecommerceConfigId;
  }, [ecommerceConfigId]);
  
  // Logo resim kütüphanesi için state
  const [isLogoLibraryModalOpen, setIsLogoLibraryModalOpen] = useState(false);
  const [logoType, setLogoType] = useState<'desktop' | 'mobile' | 'menu'>('desktop'); // Hangi logo için modal açıldı
  
  // İkon seçimi için state'ler
  const [isIconModalOpen, setIsIconModalOpen] = useState(false);
  const [iconModalCategory, setIconModalCategory] = useState<'phone' | 'cart'>('phone');
  const [iconModalCardType, setIconModalCardType] = useState<'card1' | 'card2'>('card1');
  
  // Şirket ID'sini al
  useEffect(() => {
    let isActive = true;

    const resolveCompanyId = async (user: any) => {
      if (!user) {
        if (!isActive) return;
        setCompanyId(null);
        setError('Giriş yapmış kullanıcı bulunamadı.');
        setLoading(false);
        return;
      }

      try {
        // Öncelik: AuthContext'in güncellediği localStorage userDetails (hesap geçişinde daha güncel olur)
        const stored = localStorage.getItem('userDetails');
        if (stored) {
          const details = JSON.parse(stored);
          const storedCompanyId = details?.companyId;
          if (storedCompanyId) {
            if (!isActive) return;
            setCompanyId(String(storedCompanyId));
            setError(null);
            return;
          }
        }
      } catch (storageError) {
        console.warn("userDetails parse edilemedi, Firebase'den devam ediliyor:", storageError);
      }

      try {
        const userData = await firebaseDataService.getUserData(user.uid);
        if (!isActive) return;

        if (userData?.companyId) {
          setCompanyId(String(userData.companyId));
          setError(null);
        } else {
          setCompanyId(null);
          setError('Kullanıcı şirket bilgisi bulunamadı.');
          setLoading(false);
        }
      } catch (error) {
        if (!isActive) return;
        console.error("Şirket ID'si alınırken hata:", error);
        setCompanyId(null);
        setError('Şirket ID bilgisi alınamadı.');
        setLoading(false);
      }
    };

    const unsubscribe = ownAuthSession.onAuthChange((_reason, u) => {
      const uid = u ? (u.firebaseUid || u.id) : null;
      resolveCompanyId(uid ? { uid } : null);
    });

    // İlk render'da mevcut user ile de hemen çöz (listener gecikmesine karşı)
    const currentUid = ownAuthSession.getCurrentUid();
    resolveCompanyId(currentUid ? { uid: currentUid } : null);

    return () => {
      isActive = false;
      unsubscribe();
    };
  }, []);

  // AuthContext üzerinden şirket değişirse e-ticaret paneli de hemen yeni companyId'ye geçsin.
  useEffect(() => {
    const cid = userDetails?.companyId;
    if (!cid) return;
    setCompanyId(String(cid));
    setError(null);
  }, [userDetails?.companyId]);

  // Hesap/firma değişiminde önceki firmanın header/menu state'inin taşınmasını engelle.
  useEffect(() => {
    if (!companyId) return;

    setHeaderConfigId(null);
    setMenuConfigId(null);
    setSqlHeaderConfig(null);
    setSqlMenuConfig(null);
    setSqlMenuCategories([]);

    setConfig((prev) => ({
      ...prev,
      headerSettings: {
        ...prev.headerSettings,
        enableCustomNavMenu: false,
        customNavMenu: createDefaultTopNavMenu(),
      }
    }));
  }, [companyId]);

  // NOT (Faz E): Eski RTDB `companies/{companyId}` logo/favicon okumasi kaldirildi.
  // Logo/favicon zaten SQL config yuklemesinden geliyor (currentLogoUrl <- response.data.logoUrl,
  // currentFaviconUrl <- generalResponse.data.faviconUrl).

  // E-ticaret yapılandırmasını yükle (SQL API'den - TEK SEFERLİK - PARALEL)
  useEffect(() => {
    if (!companyId) return;

    const loadConfig = async () => {
      setLoading(true);
      setError(null);

      console.log('🔄 [CONFIG LOAD] SQL API\'den config yükleniyor (paralel):', companyId);
      const startTime = performance.now();

      try {
        // TÜM API ÇAĞRILARINI PARALEL YAP (hard-fail yerine kısmi fallback)
        const [generalResult, backgroundResult] = await Promise.allSettled([
          getGeneralConfig(companyId),
          getActiveSiteBackground(companyId)
        ]);

        const generalResponse = generalResult.status === 'fulfilled' ? generalResult.value : null;
        const backgroundResponse = backgroundResult.status === 'fulfilled' ? backgroundResult.value : null;

        if (generalResult.status === 'rejected') {
          console.warn('⚠️ [CONFIG LOAD] General config alınamadı, varsayılanlar ile devam ediliyor.', generalResult.reason);
        }
        if (backgroundResult.status === 'rejected') {
          console.warn('⚠️ [CONFIG LOAD] Site background alınamadı, varsayılan arkaplan ile devam ediliyor.', backgroundResult.reason);
        }
        
        console.log(`📥 [CONFIG LOAD] Paralel API çağrıları tamamlandı: ${Math.round(performance.now() - startTime)}ms`);
        
        let configId = null;
        if (generalResponse && generalResponse.data) {
          configId = generalResponse.data.id || null;
          setEcommerceConfigId(configId);
          setCurrentFaviconUrl(generalResponse.data.faviconUrl || null);
        }

        // Tüm ayarları default ile başlat
        const mergedConfig = { ...defaultConfig };
        if (generalResponse && generalResponse.data) {
          const moduleStyle =
            generalResponse.data.homePageModuleStyle === 'module2' ? 'module2' : 'module1';
          mergedConfig.menuSettings = {
            ...mergedConfig.menuSettings,
            moduleType: moduleStyle
          };
          mergedConfig.siteName = generalResponse.data.siteName || '';
          mergedConfig.metaTitle = generalResponse.data.metaTitle || '';
          mergedConfig.metaDescription = generalResponse.data.metaDescription || '';
          mergedConfig.metaKeywords = generalResponse.data.metaKeywords || '';
        }
        
        // Site background
        if (backgroundResponse && backgroundResponse.data) {
          mergedConfig.siteBackgroundSettings = {
            type: backgroundResponse.data.backgroundType || 'color',
            backgroundColor: backgroundResponse.data.backgroundColor || '#ffffff',
            patternType: backgroundResponse.data.patternType || null
          };
          setBackgroundConfigId(backgroundResponse.data.id);
        }
        
        const totalTime = Math.round(performance.now() - startTime);
        console.log(`✅ [CONFIG LOAD] SQL config yüklendi - Toplam: ${totalTime}ms`);
        setConfig((prev) => ({
          ...mergedConfig,
          headerSettings: prev.headerSettings,
          menuSettings: {
            ...mergedConfig.menuSettings,
            ...prev.menuSettings,
            moduleType: mergedConfig.menuSettings.moduleType,
          },
          menuCategories: prev.menuCategories?.length ? prev.menuCategories : mergedConfig.menuCategories,
        }));
        
        if (mergedConfig.menuCategories && mergedConfig.menuCategories.length > 0) {
          const expandedState: Record<string, boolean> = {};
          mergedConfig.menuCategories.forEach((category: MenuCategory) => {
            expandedState[category.id] = false;
          });
          setExpandedCategories(expandedState);
        }
      } catch (error) {
        console.error("❌ [CONFIG LOAD] Beklenmeyen yükleme hatası:", error);
        // Bu blok yalnızca beklenmeyen runtime hataları için.
        // Kullanıcıyı tamamen kilitlememek için varsayılan config ile devam ediyoruz.
        setConfig(defaultConfig);
        setError(null);
      } finally {
        setLoading(false);
      }
    };
    
    loadConfig();
  }, [companyId]);
  
  // NOT: Genel Görünüm tab'ı için ayrı yükleme kaldırıldı - loadConfig zaten tüm verileri yüklüyor
  
  // Ana Sayfa tab'ına geçildiğinde SQL'den yükle (yalnızca config ilk yüklenmediyse)
  useEffect(() => {
    const loadHomePageConfigOnTabChange = async () => {
      if (activeTabId === 'homepage' && companyId && !ecommerceConfigId) {
        console.log('🔄 [HOMEPAGE TAB] Ana Sayfa tab açıldı, SQL den yükleniyor...');
        try {
          const generalResponse = await getGeneralConfig(companyId);
          console.log('📥 [HOMEPAGE TAB] SQL den gelen General Config:', generalResponse);
          
          if (generalResponse && generalResponse.data) {
            const homePageModuleStyle =
              generalResponse.data.homePageModuleStyle === 'module2' ? 'module2' : 'module1';
            
            // Config'e yükle
            setConfig(prev => ({
              ...prev,
              menuSettings: {
                ...prev.menuSettings,
                moduleType: homePageModuleStyle
              }
            }));
            
            console.log('✅ [HOMEPAGE TAB] Ana sayfa modül stili yüklendi:', homePageModuleStyle);
          }
        } catch (error) {
          console.error('❌ [HOMEPAGE TAB] Yükleme hatası:', error);
        }
      }
    };
    
    loadHomePageConfigOnTabChange();
  }, [activeTabId, companyId, ecommerceConfigId]);

  // Slider tab'ına geçildiğinde SQL'den yükle
  useEffect(() => {
    const loadSliderConfigOnTabChange = async () => {
      if (activeTabId === 'slider' && companyId && ecommerceConfigId) {
        console.log('🎠 [SLIDER TAB] Slider tab açıldı, SQL den yükleniyor...');
        try {
          const sliderResponse = await getSliderSettings(companyId, ecommerceConfigId); // ✅ companyId eklendi
          console.log('📥 [SLIDER TAB] SQL den gelen Slider Config:', sliderResponse);
          
          if (sliderResponse && sliderResponse.success && sliderResponse.data) {
            const sliderData = sliderResponse.data.slider;
            const slidesData = sliderResponse.data.slides || [];
            if (!sliderData) {
              console.warn('⚠️ [SLIDER TAB] SQL\'de slider kaydı yok, varsayılan ayarlar kullanılacak');
              return;
            }
            
            // JSON alanları parse et
            let titleSettings: any = null;
            let descriptionSettings: any = null;
            let backgroundSettings: any = null;
            
            if (sliderData.titleSettingsJson) {
              try {
                titleSettings = JSON.parse(sliderData.titleSettingsJson);
              } catch (e) {
                console.warn('Title settings parse hatası:', e);
              }
            }
            
            if (sliderData.descriptionSettingsJson) {
              try {
                descriptionSettings = JSON.parse(sliderData.descriptionSettingsJson);
              } catch (e) {
                console.warn('Description settings parse hatası:', e);
              }
            }
            
            let textMode: 'single' | 'per-slide' | 'fixed' = 'per-slide';
            let textSlideId: string | undefined;
            let textAlign: 'left' | 'center' | 'right' | undefined;
            let textPositionFromJson: string | undefined;
            let bottomDarken: { enabled: boolean; intensity: number } | undefined;
            let imageBlur: { enabled: boolean; amount: number } | undefined;
            let textInset: { mode: 'edge' | 'grid' | 'custom'; customPx?: number; offsetX?: number } | undefined;
            let showTrustStrip = false;
            let trustStripSettings: any = undefined;
            let heightWebFromJson: number | undefined;
            let heightMobileFromJson: number | undefined;
            if (sliderData.backgroundSettingsJson) {
              try {
                backgroundSettings = JSON.parse(sliderData.backgroundSettingsJson);
                if (backgroundSettings?.textOverlayMode === 'single' ||
                    backgroundSettings?.textOverlayMode === 'per-slide' ||
                    backgroundSettings?.textOverlayMode === 'fixed') {
                  textMode = backgroundSettings.textOverlayMode;
                }
                if (backgroundSettings?.textOverlaySlideId) {
                  textSlideId = String(backgroundSettings.textOverlaySlideId);
                }
                if (
                  backgroundSettings?.textAlign === 'left' ||
                  backgroundSettings?.textAlign === 'center' ||
                  backgroundSettings?.textAlign === 'right'
                ) {
                  textAlign = backgroundSettings.textAlign;
                }
                if (typeof backgroundSettings?.textPosition === 'string' && backgroundSettings.textPosition.trim()) {
                  textPositionFromJson = backgroundSettings.textPosition.trim();
                }
                if (backgroundSettings?.bottomDarken && typeof backgroundSettings.bottomDarken === 'object') {
                  const intensity = Number(backgroundSettings.bottomDarken.intensity);
                  bottomDarken = {
                    enabled: Boolean(backgroundSettings.bottomDarken.enabled),
                    intensity: Number.isFinite(intensity)
                      ? Math.min(80, Math.max(0, Math.round(intensity)))
                      : 50,
                  };
                }
                if (backgroundSettings?.imageBlur && typeof backgroundSettings.imageBlur === 'object') {
                  const amount = Number(backgroundSettings.imageBlur.amount);
                  imageBlur = {
                    enabled: Boolean(backgroundSettings.imageBlur.enabled),
                    amount: Number.isFinite(amount)
                      ? Math.min(20, Math.max(0, Math.round(amount)))
                      : 8,
                  };
                }
                if (backgroundSettings?.textInset && typeof backgroundSettings.textInset === 'object') {
                  const mode = backgroundSettings.textInset.mode;
                  const customPx = Number(backgroundSettings.textInset.customPx);
                  const offsetX = Number(backgroundSettings.textInset.offsetX);
                  textInset = {
                    mode: mode === 'edge' || mode === 'custom' ? mode : 'grid',
                    customPx: Number.isFinite(customPx)
                      ? Math.min(200, Math.max(8, Math.round(customPx)))
                      : 48,
                    offsetX: Number.isFinite(offsetX)
                      ? Math.min(160, Math.max(-160, Math.round(offsetX)))
                      : 0,
                  };
                }
                const parsedHeightWeb = Number(backgroundSettings?.heightWeb);
                if (Number.isFinite(parsedHeightWeb)) heightWebFromJson = parsedHeightWeb;
                const parsedHeightMobile = Number(backgroundSettings?.heightMobile);
                if (Number.isFinite(parsedHeightMobile)) heightMobileFromJson = parsedHeightMobile;
                if (backgroundSettings?.trustStrip && typeof backgroundSettings.trustStrip === 'object') {
                  showTrustStrip = Boolean(backgroundSettings.trustStrip.enabled);
                  const { enabled: _trustEnabled, ...restTrust } = backgroundSettings.trustStrip;
                  trustStripSettings = restTrust;
                }
                if (backgroundSettings) {
                  const {
                    textOverlayMode,
                    textOverlaySlideId,
                    textAlign: _textAlign,
                    textPosition: _bgTextPosition,
                    bottomDarken: _bottomDarken,
                    imageBlur: _imageBlur,
                    textInset: _textInset,
                    trustStrip,
                    heightWeb: _heightWeb,
                    heightMobile: _heightMobile,
                    ...cleanBg
                  } = backgroundSettings;
                  backgroundSettings = cleanBg;
                }
              } catch (e) {
                console.warn('Background settings parse hatası:', e);
              }
            }
            
            // Slides'ı dönüştür (+ üzerine yazı override'ları)
            // Pasif / "silinmiş" slaytlar panelde tekrar görünmesin
            const formattedSlides = slidesData
              .filter((slide: any) => slide?.isActive !== false && slide?.IsActive !== false)
              .map((slide: any) => {
              let overlayMeta: any = null;
              const rawSubtitle = String(slide.subtitle || '').trim();
              if (rawSubtitle.startsWith('{')) {
                try {
                  overlayMeta = JSON.parse(rawSubtitle);
                } catch {
                  overlayMeta = null;
                }
              }

              const buildStyle = (
                text: string,
                color: string | undefined,
                fontSize: number | undefined,
                fallbackSize: string,
                fallbackWeight: 'normal' | 'bold'
              ) => {
                if (!String(text || '').trim()) return undefined;
                return {
                  text: String(text).trim(),
                  color: color || '#FFFFFF',
                  fontSize: fontSize && fontSize > 0 ? `${fontSize}px` : fallbackSize,
                  fontFamily: 'Arial, sans-serif',
                  fontWeight: fallbackWeight,
                  fontStyle: 'normal' as const,
                };
              };

              const mediaUrl = String(slide.imageUrl || '').trim();
              const lower = mediaUrl.toLowerCase();
              const isVideo =
                lower.includes('.mp4') ||
                lower.includes('.webm') ||
                lower.includes('.mov') ||
                lower.includes('.m4v') ||
                lower.includes('video/');

              return {
                id: slide.id,
                mediaUrl,
                mediaType: (isVideo ? 'video' : 'image') as 'image' | 'video',
                title: slide.title || '',
                active: slide.isActive,
                mobileMediaUrl: slide.mobileImageUrl,
                overrideTitle: overlayMeta?.overrideTitle?.text
                  ? overlayMeta.overrideTitle
                  : undefined,
                overrideDescription:
                  overlayMeta?.overrideDescription ||
                  buildStyle(
                    slide.description,
                    slide.descriptionColor,
                    slide.descriptionFontSize,
                    '18px',
                    'normal'
                  ),
                overrideTextPosition: (() => {
                  const raw = String(overlayMeta?.overrideTextPosition || '').trim();
                  const normalized = raw.toLowerCase().replace(/[_\s]+/g, '-');
                  if (!raw || normalized === 'center' || normalized === 'middle-center') return undefined;
                  return raw;
                })(),
                overrideTextAlign:
                  overlayMeta?.overrideTextAlign === 'left' ||
                  overlayMeta?.overrideTextAlign === 'center' ||
                  overlayMeta?.overrideTextAlign === 'right'
                    ? overlayMeta.overrideTextAlign
                    : undefined,
                overrideTextAnimation: overlayMeta?.overrideTextAnimation || undefined,
                overlayArea:
                  overlayMeta?.overlayArea === 'left' ||
                  overlayMeta?.overlayArea === 'center' ||
                  overlayMeta?.overlayArea === 'right' ||
                  overlayMeta?.overlayArea === 'full'
                    ? overlayMeta.overlayArea
                    : undefined,
                buttons: (() => {
                  const packed = String(slide.buttonStyle || '').split('|');
                  const packedStyle = (packed[0] || 'primary').trim() || 'primary';
                  const packedAction = (packed[1] || '').trim();
                  const mapOne = (raw: any, fallbackCols = false) => {
                    const label = String(raw?.label || (fallbackCols ? slide.buttonText : '') || '').trim();
                    const explicitShow = raw?.show;
                    const show =
                      explicitShow === false || explicitShow === 'false' || explicitShow === 0
                        ? false
                        : Boolean(
                            explicitShow ??
                              (fallbackCols ? slide.showButton : label.length > 0)
                          );
                    return {
                      show,
                      label,
                      action: raw?.action || packedAction || (slide.buttonUrl ? 'external-url' : 'none'),
                      target: String(raw?.target || (fallbackCols ? slide.buttonUrl : '') || '').trim(),
                      style: raw?.style || packedStyle,
                      formSlug: String(raw?.formSlug || '').trim() || undefined,
                      formTitle: String(raw?.formTitle || '').trim() || undefined,
                      templateId: String(raw?.templateId || '').trim() || undefined,
                      size: raw?.size === 'sm' || raw?.size === 'lg' ? raw.size : raw?.size === 'md' ? 'md' : undefined,
                      placement: String(raw?.placement || '').trim() || undefined,
                      backgroundColor: String(raw?.backgroundColor || '').trim() || undefined,
                      textColor: String(raw?.textColor || '').trim() || undefined,
                      borderColor: String(raw?.borderColor || '').trim() || undefined,
                      borderRadius: raw?.borderRadius === 'full' ? 'full' : raw?.borderRadius === 'md' ? 'md' : undefined,
                    };
                  };

                  if (Array.isArray(overlayMeta?.buttons) && overlayMeta.buttons.length > 0) {
                    return overlayMeta.buttons.map((b: any) => mapOne(b));
                  }
                  if (overlayMeta?.button && typeof overlayMeta.button === 'object') {
                    return [mapOne(overlayMeta.button)];
                  }
                  if (slide.showButton && (slide.buttonText || slide.buttonUrl)) {
                    return [mapOne({}, true)];
                  }
                  return undefined;
                })(),
                button: (() => {
                  const packed = String(slide.buttonStyle || '').split('|');
                  const packedStyle = (packed[0] || 'primary').trim() || 'primary';
                  const packedAction = (packed[1] || '').trim();
                  const fromOverlay = Array.isArray(overlayMeta?.buttons) && overlayMeta.buttons[0]
                    ? overlayMeta.buttons[0]
                    : overlayMeta?.button;
                  if (fromOverlay && typeof fromOverlay === 'object') {
                    return {
                      show: Boolean(fromOverlay.show ?? slide.showButton),
                      label: String(fromOverlay.label || slide.buttonText || '').trim(),
                      action: fromOverlay.action || packedAction || (slide.buttonUrl ? 'external-url' : 'none'),
                      target: String(fromOverlay.target || slide.buttonUrl || '').trim(),
                      style: fromOverlay.style || packedStyle,
                      formSlug: String(fromOverlay.formSlug || '').trim() || undefined,
                      formTitle: String(fromOverlay.formTitle || '').trim() || undefined,
                      templateId: String(fromOverlay.templateId || '').trim() || undefined,
                      size: fromOverlay.size,
                      placement: fromOverlay.placement,
                      backgroundColor: fromOverlay.backgroundColor,
                      textColor: fromOverlay.textColor,
                      borderColor: fromOverlay.borderColor,
                      borderRadius: fromOverlay.borderRadius,
                    };
                  }
                  if (slide.showButton && (slide.buttonText || slide.buttonUrl)) {
                    return {
                      show: true,
                      label: String(slide.buttonText || '').trim(),
                      action: packedAction || (slide.buttonUrl ? 'external-url' : 'none'),
                      target: String(slide.buttonUrl || '').trim(),
                      style: packedStyle,
                    };
                  }
                  return undefined;
                })(),
              };
            });
            
            // Config'e yükle
            setConfig(prev => ({
              ...prev,
              sliderSettings: {
                enabled: sliderData.showSlider,
                autoplay: sliderData.autoPlay,
                interval: sliderData.autoPlayInterval,
                height: {
                  web: (() => {
                    const n = heightWebFromJson ?? Number(sliderData.height);
                    if (!Number.isFinite(n) || n < 30 || n > 140) return 60;
                    return n;
                  })(),
                  mobile: (() => {
                    const n = heightMobileFromJson ?? Number(sliderData.mobileHeight);
                    if (!Number.isFinite(n) || n < 25 || n > 80) return 40;
                    return n;
                  })(),
                },
                slides: formattedSlides,
                title: titleSettings,
                description: descriptionSettings,
                background: backgroundSettings,
                textPosition: sliderData.textPosition || textPositionFromJson,
                textAlign,
                bottomDarken,
                imageBlur,
                textInset,
                textAnimation: sliderData.textAnimation,
                textMode,
                textSlideId,
                showTrustStrip,
                trustStripSettings,
              }
            }));
            
            console.log('✅ [SLIDER TAB] Slider ayarları yüklendi');
          }
        } catch (error) {
          console.error('❌ [SLIDER TAB] Yükleme hatası:', error);
        }
      }
    };
    
    loadSliderConfigOnTabChange();
  }, [activeTabId, companyId, ecommerceConfigId]);

  // Kategoriler tab'ına geçildiğinde SQL'den yükle
  useEffect(() => {
    const loadCategoryConfigOnTabChange = async () => {
      if (activeTabId === 'categories' && companyId) {
        console.log('📂 [CATEGORY TAB] Kategoriler tab açıldı, SQL den yükleniyor...');
        
        // Eğer ecommerceConfigId yoksa, önce onu al
        let configIdToUse = ecommerceConfigId;
        if (!configIdToUse) {
          console.log('📂 [CATEGORY TAB] EcommerceConfigId yok, önce genel config alınıyor...');
          try {
            const generalResponse = await getGeneralConfig(companyId);
            if (generalResponse && generalResponse.data) {
              configIdToUse = generalResponse.data.id || null;
              setEcommerceConfigId(configIdToUse);
              console.log('✅ [CATEGORY TAB] EcommerceConfigId set edildi:', configIdToUse);
            }
          } catch (error) {
            console.error('❌ [CATEGORY TAB] EcommerceConfigId alma hatası:', error);
            return;
          }
        }
        
        if (!configIdToUse) {
          console.warn('⚠️ [CATEGORY TAB] ConfigId alınamadı, yükleme iptal edildi');
          return;
        }
        
        try {
          const categoryResponse = await getCategorySettings(companyId, configIdToUse); // ✅ companyId eklendi
          console.log('📥 [CATEGORY TAB] SQL den gelen Category Config:', categoryResponse);
          console.log('📥 [CATEGORY TAB] Raw Data:', {
            showCategoriesOnHomepage: categoryResponse?.data?.showCategoriesOnHomepage,
            homepageCategoryLayout: categoryResponse?.data?.homepageCategoryLayout,
            mobileCategoryLayout: categoryResponse?.data?.mobileCategoryLayout,
            id: categoryResponse?.data?.id,
            configId: categoryResponse?.data?.configId
          });
          
          if (categoryResponse && categoryResponse.success && categoryResponse.data) {
            const normalizedCategorySettings = normalizeCategorySettingsFromApi(categoryResponse.data);

            if (normalizedCategorySettings) {
              setConfig(prev => ({
                ...prev,
                categorySettings: normalizedCategorySettings,
              }));
            }
            
            console.log('✅ [CATEGORY TAB] Kategori ayarları yüklendi', normalizedCategorySettings);
          }
        } catch (error) {
          console.error('❌ [CATEGORY TAB] Yükleme hatası:', error);
        }
      }
    };
    
    loadCategoryConfigOnTabChange();
  }, [activeTabId, companyId]); // ecommerceConfigId dependency'den çıkarıldı - içerde kontrol ediliyor

  // Header tab'ına geçildiğinde SQL'den yükle
  useEffect(() => {
    const loadHeaderConfigOnTabChange = async () => {
      if (activeTabId === 'header' && companyId) {
        console.log('🔄 [HEADER TAB] === HEADER TAB YÜKLEME BAŞLANGIÇ ===');
        console.log('🔄 [HEADER TAB] Header tab açıldı, SQL den yeniden yükleniyor...');
        console.log('🔄 [HEADER TAB] CompanyId:', companyId);
        console.log('🔄 [HEADER TAB] Mevcut HeaderConfigId:', headerConfigId);
        
        setLoadingHeaderConfig(true);
        const loadGen = headerLocalEditGenRef.current;
        try {
          const response = await getHeaderConfig(companyId);
          if (loadGen !== headerLocalEditGenRef.current) {
            console.log('⏭️ [HEADER TAB] Kullanıcı düzenlemesi var, gecikmiş SQL yüklemesi yok sayılıyor');
            return;
          }
          console.log('📥 [HEADER TAB] SQL den gelen Header Config (RAW):', JSON.stringify(response, null, 2));
          console.log('📥 [HEADER TAB] response.success:', response?.success);
          console.log('📥 [HEADER TAB] response.message:', response?.message);
          console.log('📥 [HEADER TAB] response.data:', response?.data);
          console.log('📥 [HEADER TAB] response.data tipi:', typeof response?.data);
          console.log('📥 [HEADER TAB] response.data === null?', response?.data === null);
          
          if (response && response.data) {
            console.log('✅ [HEADER TAB] Header ayarları SQL de bulundu, yükleniyor...');
            console.log('📋 [HEADER TAB] Header Config ID:', response.data.id);
            
            setSqlHeaderConfig(response.data);
            setHeaderConfigId(response.data.id);
            
            // SQL'den gelen verileri state'e map et
            setConfig(prev => ({
              ...prev,
              headerSettings: {
                ...prev.headerSettings,
                headerType: normalizeHeaderType(response.data.headerStyle ?? response.data.headerType),
                enabled: response.data.showHeader !== undefined
                  ? response.data.showHeader
                  : (response.data.showTopBar !== undefined ? response.data.showTopBar : true),
                searchType: (() => {
                  const type = response.data.searchType || 'product';
                  if (type === 'none' || response.data.showSearchBar === false) return 'none';
                  return type;
                })(),
                verticalPadding: response.data.verticalPadding || 16,
                backgroundColor: response.data.backgroundColor || '#ffffff',
                textColor: response.data.textColor || '#212121',
                showSearch: (() => {
                  const type = response.data.searchType || 'product';
                  if (type === 'none') return false;
                  return response.data.showSearchBar !== undefined ? response.data.showSearchBar : true;
                })(),
                showCart: response.data.showCart !== undefined ? response.data.showCart : true,
                showUserMenu: response.data.showUserMenu !== undefined ? response.data.showUserMenu : true,
                showUserIcon: response.data.showUserIcon !== undefined ? response.data.showUserIcon : true,
                showMobileCategories: response.data.showMobileCategories !== undefined ? response.data.showMobileCategories : true,
                showBecomeSellerButton: response.data.showBecomeSellerButton !== undefined
                  ? response.data.showBecomeSellerButton
                  : (response.data.showLanguageSwitcher !== undefined ? response.data.showLanguageSwitcher : false),
                showBottomNavbar: response.data.showBottomNavbar !== undefined ? response.data.showBottomNavbar : true,
                showHeaderInfoStrip: response.data.showHeaderInfoStrip === true,
                headerInfoStripText: typeof response.data.headerInfoStripText === 'string'
                  ? response.data.headerInfoStripText
                  : '',
                headerInfoStripBackgroundColor: response.data.headerInfoStripBackgroundColor || '#7ED957',
                headerInfoStripTextColor: response.data.headerInfoStripTextColor || '#111111',
                showHeaderMarqueeStrip: response.data.showHeaderMarqueeStrip === true,
                headerMarqueeStripText: typeof response.data.headerMarqueeStripText === 'string'
                  ? response.data.headerMarqueeStripText
                  : '',
                headerMarqueeStripBackgroundColor: response.data.headerMarqueeStripBackgroundColor || '#0f172a',
                headerMarqueeStripTextColor: response.data.headerMarqueeStripTextColor || '#ffffff',
                headerMarqueeSpeedSeconds: Number(response.data.headerMarqueeSpeedSeconds || 18),
                showLogo: response.data.showLogo !== false,
                logoUrl: response.data.logoUrl || prev.headerSettings.logoUrl,
                logoWidth: response.data.logoWidth || 120,
                logoHeight: response.data.logoHeight || 50,
                logoAlign: response.data.logoAlign || 'left',
                mobileLogoUrl: response.data.mobileLogoUrl || prev.headerSettings.mobileLogoUrl,
                favoriteIcon: response.data.favoriteIcon || 'favorite-1',
                cartIcon: response.data.cartIcon || 'cart-1',
                userIcon: response.data.userIcon || 'user-1',
                iconSize: response.data.iconSize || 24,
                // Header4 Kartlar
                header4Cards: {
                  card1: {
                    enabled: response.data.header4Card1Enabled !== undefined ? response.data.header4Card1Enabled : true,
                    text: response.data.header4Card1Text || '',
                    backgroundColor: response.data.header4Card1BackgroundColor || '#ffffff',
                    textColor: response.data.header4Card1TextColor || '#212121',
                    iconUrl: response.data.header4Card1IconUrl || '',
                    linkUrl: response.data.header4Card1LinkUrl || ''
                  },
                  card2: {
                    enabled: response.data.header4Card2Enabled !== undefined ? response.data.header4Card2Enabled : true,
                    text: response.data.header4Card2Text || '',
                    backgroundColor: response.data.header4Card2BackgroundColor || '#ffffff',
                    textColor: response.data.header4Card2TextColor || '#212121',
                    iconUrl: response.data.header4Card2IconUrl || '',
                    linkUrl: response.data.header4Card2LinkUrl || ''
                  }
                },
                // Header6 (Restoran/Brand) ayarlari
                enableCustomNavMenu: response.data.enableCustomNavMenu === true,
                customNavMenu: (() => {
                  const raw = response.data.customNavMenuJson;
                  if (!raw) return createDefaultTopNavMenu();
                  try {
                    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
                    if (!Array.isArray(parsed)) return createDefaultTopNavMenu();
                    return normalizeCustomNavMenu(stripNavbarExtrasItem(parsed));
                  } catch {
                    return createDefaultTopNavMenu();
                  }
                })(),
                orderButtonIcon: response.data.orderButtonIcon || 'order-1',
                orderButtonText: response.data.orderButtonText || 'SİPARİŞ VER',
                orderButtonUrl: response.data.orderButtonUrl || '/cart',
                orderButtonBackgroundColor: response.data.orderButtonBackgroundColor || '#e63946',
                orderButtonTextColor: response.data.orderButtonTextColor || '#ffffff',
                showOrderButton: response.data.showOrderButton === true,
                header6AdvancedStyleEnabled: response.data.header6AdvancedStyleEnabled === true,
                header6LogoAlign: (response.data.header6LogoAlign || 'left') as 'left' | 'center' | 'right',
                header6MenuFontSize: Number(response.data.header6MenuFontSize || 14),
                header6MenuFontWeight: Number(response.data.header6MenuFontWeight || 700),
                header6MenuTextTransform: (response.data.header6MenuTextTransform || 'uppercase') as 'none' | 'uppercase' | 'lowercase' | 'capitalize',
                header6MenuItalic: response.data.header6MenuItalic === true,
                header6MenuFontFamily: response.data.header6MenuFontFamily || 'Inter, sans-serif',
                header6MenuItemColor: response.data.header6MenuItemColor || '#ffffff',
                header6MenuLetterSpacing: Number(response.data.header6MenuLetterSpacing ?? 0.6),
                ...resolveHeaderNavbarExtras(response.data, response.data.customNavMenuJson),
              }
            }));
            
            if (response.data.logoUrl) {
              setCurrentLogoUrl(response.data.logoUrl);
            }
            
            console.log('✅ [HEADER TAB] Header ayarları başarıyla yüklendi');
          } else if (loadGen === headerLocalEditGenRef.current) {
            console.warn('⚠️ [HEADER TAB] SQL de header ayarları bulunamadı (data: null)');
            console.log('🆕 [HEADER TAB] İlk kullanım, default ayarlar kullanılacak');
            console.log('🆕 [HEADER TAB] HeaderConfigId henüz set edilmedi, ilk değişiklikte oluşturulacak');
            
            // ✅ Default ayarları yükle (hiç kayıt yoksa)
            setConfig(prev => ({
              ...prev,
              headerSettings: {
                ...prev.headerSettings,
                headerType: prev.headerSettings.headerType || 'header1',
                enabled: prev.headerSettings.enabled !== undefined ? prev.headerSettings.enabled : true,
                searchType: prev.headerSettings.searchType || 'product',
                verticalPadding: prev.headerSettings.verticalPadding || 16,
                backgroundColor: prev.headerSettings.backgroundColor || '#ffffff',
                textColor: prev.headerSettings.textColor || '#212121',
                showSearch: prev.headerSettings.showSearch !== undefined ? prev.headerSettings.showSearch : true,
                showCart: prev.headerSettings.showCart !== undefined ? prev.headerSettings.showCart : true,
                showUserMenu: prev.headerSettings.showUserMenu !== undefined ? prev.headerSettings.showUserMenu : true,
                showUserIcon: prev.headerSettings.showUserIcon !== undefined ? prev.headerSettings.showUserIcon : true,
                showMobileCategories: prev.headerSettings.showMobileCategories !== undefined ? prev.headerSettings.showMobileCategories : true,
                showBecomeSellerButton: prev.headerSettings.showBecomeSellerButton !== undefined ? prev.headerSettings.showBecomeSellerButton : false,
                showBottomNavbar: prev.headerSettings.showBottomNavbar !== undefined ? prev.headerSettings.showBottomNavbar : true,
                showHeaderInfoStrip: prev.headerSettings.showHeaderInfoStrip === true,
                headerInfoStripText: typeof prev.headerSettings.headerInfoStripText === 'string'
                  ? prev.headerSettings.headerInfoStripText
                  : '',
                headerInfoStripBackgroundColor: prev.headerSettings.headerInfoStripBackgroundColor || '#7ED957',
                headerInfoStripTextColor: prev.headerSettings.headerInfoStripTextColor || '#111111',
                showHeaderMarqueeStrip: prev.headerSettings.showHeaderMarqueeStrip === true,
                headerMarqueeStripText: typeof prev.headerSettings.headerMarqueeStripText === 'string'
                  ? prev.headerSettings.headerMarqueeStripText
                  : '',
                headerMarqueeStripBackgroundColor: prev.headerSettings.headerMarqueeStripBackgroundColor || '#0f172a',
                headerMarqueeStripTextColor: prev.headerSettings.headerMarqueeStripTextColor || '#ffffff',
                headerMarqueeSpeedSeconds: Number(prev.headerSettings.headerMarqueeSpeedSeconds || 18),
                showLogo: prev.headerSettings.showLogo !== undefined ? prev.headerSettings.showLogo : true,
                logoUrl: prev.headerSettings.logoUrl || undefined,
                logoWidth: prev.headerSettings.logoWidth || 120,
                mobileLogoUrl: prev.headerSettings.mobileLogoUrl || undefined,
                favoriteIcon: prev.headerSettings.favoriteIcon || 'favorite-1',
                cartIcon: prev.headerSettings.cartIcon || 'cart-1',
                userIcon: prev.headerSettings.userIcon || 'user-1',
                iconSize: prev.headerSettings.iconSize || 24,
                // Hesap degistiginde onceki hesabin custom menu verisini tasimayalim.
                // Toggle kapali, ic menu defaultlarla dolu basliyor.
                enableCustomNavMenu: false,
                customNavMenu: createDefaultTopNavMenu(),
                header6AdvancedStyleEnabled: false,
                header6LogoAlign: 'left',
                header6MenuFontSize: 14,
                header6MenuFontWeight: 700,
                header6MenuTextTransform: 'uppercase',
                header6MenuItalic: false,
                header6MenuFontFamily: 'Inter, sans-serif',
                header6MenuItemColor: '#ffffff',
                header6MenuLetterSpacing: 0.6,
              }
            }));
          }
        } catch (error: any) {
          console.error('❌ [HEADER TAB] Header Config yüklenirken hata:', error);
          console.error('❌ [HEADER TAB] Hata detayı:', error.response?.data || error.message);
        } finally {
          setLoadingHeaderConfig(false);
          console.log('🔄 [HEADER TAB] === HEADER TAB YÜKLEME BİTİŞ ===');
        }
      }
    };
    
    loadHeaderConfigOnTabChange();
  }, [activeTabId, companyId]);
  
  // Menu tab'ına geçildiğinde SQL'den yükle
  useEffect(() => {
    const loadMenuConfigOnTabChange = async () => {
      if ((activeTabId === 'menus' || activeTabId === 'corporate-nav') && companyId) {
        console.log('🔄 [MENU TAB] Menu tab açıldı, SQL den yeniden yükleniyor...');
        setLoadingMenuConfig(true);
        try {
          const response = await getMenuConfig(companyId);
          console.log('📥 [MENU TAB] SQL den gelen Menu Config:', response);
          
          if (response && response.data) {
            setSqlMenuConfig(response.data);
            // ConfigId'yi set et (EcommerceConfig.Id)
            setMenuConfigId(response.data.configId);
            menuConfigIdRef.current = response.data.configId ?? null;
            
            // SQL'den gelen verileri state'e map et
            setConfig(prev => ({
              ...prev,
              menuSettings: {
                ...prev.menuSettings,
                enabled: response.data.enabled !== undefined ? response.data.enabled : true,
                menuType: response.data.menuType || 'menu1',
                menuPosition: response.data.menuPosition || 'center',
                verticalPadding: response.data.verticalPadding || 12,
                backgroundColor: response.data.backgroundColor || '#ffffff',
                textColor: response.data.textColor || '#111827',
                textTransform: response.data.textTransform || 'none',
                directCategoryLinks: response.data.enableMegaMenu === true || response.data.directCategoryLinks === true,
                menuItemSource:
                  response.data.menuStyle === 'brands' || response.data.menuItemSource === 'brands'
                    ? 'brands'
                    : 'categories',
                showAllCategories: response.data.showAllCategories !== undefined ? response.data.showAllCategories : true,
                showHomePage: response.data.showHomePage !== undefined ? response.data.showHomePage : true,
                corporateNavDisplayMode:
                  response.data.corporateNavDisplayMode === 'panel' ? 'panel' : 'dropdown',
                corporateSidebarSettings: parseCorporateSidebarSettingsJson(
                  response.data.corporateSidebarSettingsJson
                ),
                corporateSidebarLayoutMode: resolveCorporateSidebarLayoutMode({
                  corporateSidebarLayoutMode: response.data.corporateSidebarLayoutMode,
                  corporateSidebarSettingsJson: response.data.corporateSidebarSettingsJson,
                }),
                showQuoteButton: response.data.showQuoteButton === true,
                quoteButtonTitle: response.data.quoteButtonTitle || 'Teklif Al',
                quoteButtonSubtitle: response.data.quoteButtonSubtitle || 'Hemen arayın, size özel teklif hazırlayalım',
                quoteButtonLink: response.data.quoteButtonLink || '/contact',
                showMenuLeftLogo: response.data.showDropdownIcons !== undefined ? response.data.showDropdownIcons : false,
              }
            }));
            
            console.log('✅ [MENU TAB] Menu ayarları başarıyla yüklendi');
            
            // Kategorileri de yükle
            if (response.data.configId) {
              await loadMenuCategories(companyId, response.data.configId);
            }
          }
        } catch (error) {
          console.error('❌ [MENU TAB] Menu Config yüklenirken hata:', error);
        } finally {
          setLoadingMenuConfig(false);
        }
      }
    };
    
    loadMenuConfigOnTabChange();
  }, [activeTabId, companyId]);
  
  // Menu kategorilerini SQL'den yükle
  const loadMenuCategories = async (companyId: string, configId: string) => {
    setLoadingMenuCategories(true);
    try {
      console.log('🔄 [MENU CATEGORIES] Kategoriler SQL den yükleniyor...', { companyId, configId });
      const response = await getMenuCategories(companyId, configId);
      console.log('📥 [MENU CATEGORIES] SQL den gelen kategoriler:', response);
      
      if (response && response.data) {
        const enriched = await enrichMenuCategoriesWithInventoryHierarchy(response.data);
        setSqlMenuCategories(enriched);
        console.log('✅ [MENU CATEGORIES] Kategoriler başarıyla yüklendi:', response.data.length, 'kategori');
      }
    } catch (error) {
      console.error('❌ [MENU CATEGORIES] Kategoriler yüklenirken hata:', error);
    } finally {
      setLoadingMenuCategories(false);
    }
  };
  
  // Kategori görünürlüğünü değiştir
  const handleToggleCategoryVisibility = async (categoryId: string, isVisible: boolean) => {
    if (!companyId || !menuConfigId) {
      console.error('❌ [TOGGLE VISIBILITY] CompanyId veya MenuConfigId bulunamadı');
      return;
    }
    
    try {
      console.log('🔄 [TOGGLE VISIBILITY] Kategori görünürlüğü değiştiriliyor...', { categoryId, isVisible });
      
      const response = await saveMenuCategory({
        companyId: companyId,
        configId: menuConfigId,
        categoryId,
        isVisible
      });
      
      if (response.success) {
        // Local state'i güncelle
        setSqlMenuCategories(prev => 
          prev.map(cat => 
            cat.categoryId === categoryId ? { ...cat, isVisible } : cat
          )
        );
        console.log('✅ [TOGGLE VISIBILITY] Kategori görünürlüğü başarıyla değiştirildi');
      }
    } catch (error) {
      console.error('❌ [TOGGLE VISIBILITY] Hata:', error);
      setError('Kategori görünürlüğü değiştirilirken bir hata oluştu.');
    }
  };
  
  const moveCategoryInGroup = async (categoryId: string, group: 'main' | 'sub', direction: 'up' | 'down') => {
    const groupItems = (group === 'main' ? mainMenuCategories : subMenuCategories)
      .slice()
      .sort((a: any, b: any) => Number(a.displayOrder ?? 0) - Number(b.displayOrder ?? 0));

    const index = groupItems.findIndex((item) => item.categoryId === categoryId);
    if (index === -1) return;
    if (direction === 'up' && index === 0) return;
    if (direction === 'down' && index === groupItems.length - 1) return;

    const nextItems = [...groupItems];
    const swapIndex = direction === 'up' ? index - 1 : index + 1;
    [nextItems[index], nextItems[swapIndex]] = [nextItems[swapIndex], nextItems[index]];

    // DisplayOrder değerleri aynı/tekrarlı olabilir. Bu durumda taşıma görünürde olur ama kayda yansımaz.
    // Her yeniden sıralamada gruba benzersiz ve artan sıra numarası ver.
    const normalizedOrders = [...groupItems]
      .map((item) => Number(item.displayOrder ?? 0))
      .filter((value) => Number.isFinite(value))
      .sort((a, b) => a - b);
    const baseOrder = normalizedOrders.length > 0 ? normalizedOrders[0] : 0;

    const reassigned = new Map<string, number>();
    nextItems.forEach((item, idx) => {
      reassigned.set(item.categoryId, baseOrder + idx);
    });

    const updatedCategories = sqlMenuCategories.map((category) =>
      reassigned.has(category.categoryId)
        ? { ...category, displayOrder: reassigned.get(category.categoryId) }
        : category
    );

    setSqlMenuCategories(updatedCategories);
    await saveCategoryOrder(updatedCategories);
  };

  // Kategoriyi yukarı taşı
  const handleMoveCategoryUp = async (categoryId: string, group: 'main' | 'sub') => {
    await moveCategoryInGroup(categoryId, group, 'up');
  };
  
  // Kategoriyi aşağı taşı
  const handleMoveCategoryDown = async (categoryId: string, group: 'main' | 'sub') => {
    await moveCategoryInGroup(categoryId, group, 'down');
  };
  
  // Kategori sıralamasını kaydet
  const saveCategoryOrder = async (categories: any[]) => {
    if (!menuConfigId) {
      console.error('❌ [SAVE ORDER] MenuConfigId bulunamadı');
      return;
    }
    
    try {
      console.log('🔄 [SAVE ORDER] Kategori sıralaması kaydediliyor...');
      
      const response = await reorderMenuCategories({
        companyId: companyId,
        configId: menuConfigId,
        categories: categories.map(cat => ({
          categoryId: cat.categoryId,
          displayOrder: cat.displayOrder
        }))
      });
      
      if (response.success) {
        console.log('✅ [SAVE ORDER] Kategori sıralaması başarıyla kaydedildi');
      }
    } catch (error) {
      console.error('❌ [SAVE ORDER] Hata:', error);
      setError('Kategori sıralaması kaydedilirken bir hata oluştu.');
    }
  };
  
  // Kategori resmi seçme/güncelleme modalını aç
  // (Güncelleme modunda modal, mevcut resmin bulunduğu klasörü otomatik açar)
  const handleOpenCategoryImageModal = (categoryId: string, imageType: 'category' | 'banner') => {
    setSelectedCategoryForImage({ categoryId, imageType });
    setIsCategoryImageModalOpen(true);
  };

  // Kategori resmini büyük ekranda göster
  const handleViewCategoryImage = (categoryId: string, imageType: 'category' | 'banner') => {
    const category = sqlMenuCategories.find(c => c.categoryId === categoryId);
    const url = imageType === 'category' ? category?.categoryImageUrl : category?.bannerImageUrl;
    if (url) {
      setCategoryImageView({ url, name: category?.categoryName || t('ecommerceImageLibraryNames.category') });
    }
  };

  // Kategori resmini kaldırma onayını aç
  const handleRemoveCategoryImageRequest = (categoryId: string, imageType: 'category' | 'banner') => {
    const category = sqlMenuCategories.find(c => c.categoryId === categoryId);
    setCategoryImageRemoveTarget({
      categoryId,
      imageType,
      name: category?.categoryName || t('ecommerceImageLibraryNames.category'),
    });
  };

  // Kategori resmini tamamen kaldır (diğer resim alanı korunur)
  const confirmRemoveCategoryImage = async () => {
    if (!categoryImageRemoveTarget || !companyId || !menuConfigId) return;
    const { categoryId, imageType } = categoryImageRemoveTarget;
    const category = sqlMenuCategories.find(c => c.categoryId === categoryId);

    try {
      setIsRemovingCategoryImage(true);
      const response = await saveMenuCategory({
        companyId,
        configId: menuConfigId,
        categoryId,
        // Hedef alanı null yap, diğerini koru
        categoryImageUrl: imageType === 'category' ? null : (category?.categoryImageUrl ?? null),
        bannerImageUrl: imageType === 'banner' ? null : (category?.bannerImageUrl ?? null),
      });

      if (response?.success) {
        setSqlMenuCategories(prev =>
          prev.map(cat =>
            cat.categoryId === categoryId
              ? { ...cat, [imageType === 'category' ? 'categoryImageUrl' : 'bannerImageUrl']: null }
              : cat
          )
        );
      }
    } catch (error) {
      console.error('❌ [REMOVE CATEGORY IMAGE] Hata:', error);
      setError('Kategori resmi kaldırılırken bir hata oluştu.');
    } finally {
      setIsRemovingCategoryImage(false);
      setCategoryImageRemoveTarget(null);
    }
  };

  // Kategori resmi seçme modalını kapat
  const handleCloseCategoryImageModal = () => {
    setIsCategoryImageModalOpen(false);
    setSelectedCategoryForImage(null);
  };
  
  // Kategori resmi kaydet
  const handleSaveCategoryImage = async (selectedImageUrls: string[]) => {
    if (!selectedCategoryForImage || !companyId || !menuConfigId || selectedImageUrls.length === 0) {
      console.error('❌ [SAVE CATEGORY IMAGE] Gerekli bilgiler eksik');
      return;
    }
    
    const selectedImageUrl = selectedImageUrls[0]; // İlk resmi al
    
    try {
      console.log('🔄 [SAVE CATEGORY IMAGE] Kategori resmi kaydediliyor...', {
        categoryId: selectedCategoryForImage.categoryId,
        imageType: selectedCategoryForImage.imageType,
        imageUrl: selectedImageUrl
      });
      
      const existingCategory = sqlMenuCategories.find(c => c.categoryId === selectedCategoryForImage.categoryId);

      // Her iki resim alanını da gönder; sadece hedef alanı değiştir, diğerini koru
      const updateData: any = {
        companyId: companyId,
        configId: menuConfigId,
        categoryId: selectedCategoryForImage.categoryId,
        categoryImageUrl: selectedCategoryForImage.imageType === 'category'
          ? selectedImageUrl
          : (existingCategory?.categoryImageUrl ?? null),
        bannerImageUrl: selectedCategoryForImage.imageType === 'banner'
          ? selectedImageUrl
          : (existingCategory?.bannerImageUrl ?? null),
      };

      const response = await saveMenuCategory(updateData);
      
      if (response.success) {
        // Local state'i güncelle
        setSqlMenuCategories(prev => 
          prev.map(cat => 
            cat.categoryId === selectedCategoryForImage.categoryId 
              ? { 
                  ...cat, 
                  [selectedCategoryForImage.imageType === 'category' ? 'categoryImageUrl' : 'bannerImageUrl']: selectedImageUrl 
                } 
              : cat
          )
        );
        console.log('✅ [SAVE CATEGORY IMAGE] Kategori resmi başarıyla kaydedildi');
        handleCloseCategoryImageModal();
      }
    } catch (error) {
      console.error('❌ [SAVE CATEGORY IMAGE] Hata:', error);
      setError('Kategori resmi kaydedilirken bir hata oluştu.');
    }
  };


  // Yapılandırma değişikliklerini kaydet
  const saveConfig = async () => {
    if (!companyId) {
      setError("Şirket ID bulunamadı.");
      return;
    }
    
    console.log('💾 [SAVE CONFIG] SQL API üzerinden config kaydediliyor:', {
      companyId,
      hasMenuCategories: !!config.menuCategories,
      menuCategoriesLength: config.menuCategories.length
    });
    
    setIsSaving(true);
    setError(null);

    try {
      // SQL API üzerinden genel config'i kaydet
      await saveGeneralConfig({
        companyId: companyId,
        id: ecommerceConfigId || undefined
      });
      console.log("✅ [SAVE CONFIG] E-ticaret yapılandırması SQL'e kaydedildi.");
    } catch (error) {
      console.error("❌ [SAVE CONFIG] Yapılandırma kaydedilirken hata:", error);
      setError("Yapılandırma kaydedilirken bir hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  // Header ayarları değişikliği (otomatik kayıt ile)
  const handleHeaderSettingChange = (setting: keyof typeof config.headerSettings, value: any) => {
    headerLocalEditGenRef.current += 1;
    // State'i güncelle
    setConfig(prev => {
      const nextTemplate = setting === 'headerType' ? getHeaderTemplate(value) : getHeaderTemplate(prev.headerSettings?.headerType);
      const nextCaps = nextTemplate.capabilities;
      const isHeaderTypeChange = setting === 'headerType';
      const isEnablingCustomNav = setting === 'enableCustomNavMenu' && value === true;
      const isHeaderEnabled = setting === 'enabled' && value === true;

      const headerTypeOverrides = isHeaderTypeChange
        ? {
            enableCustomNavMenu: nextCaps.inlineNav ? prev.headerSettings.enableCustomNavMenu === true : false,
            customNavMenu: Array.isArray(prev.headerSettings.customNavMenu) ? prev.headerSettings.customNavMenu : [],
            ...(nextCaps.orderButton
              ? {
                  backgroundColor: prev.headerSettings.backgroundColor || '#000000',
                  textColor: prev.headerSettings.textColor || '#ffffff',
                }
              : {}),
            ...(nextCaps.overlay
              ? {
                  backgroundColor:
                    prev.headerSettings.backgroundColor && prev.headerSettings.backgroundColor !== '#000000'
                      ? prev.headerSettings.backgroundColor
                      : '#ffffff',
                  textColor:
                    prev.headerSettings.textColor && prev.headerSettings.textColor !== '#ffffff'
                      ? prev.headerSettings.textColor
                      : '#111111',
                  logoAlign: 'center',
                }
              : {}),
          }
        : null;

      // Header Üst Menüsü toggle'i AÇILDIĞINDA mevcut menü boşsa default sayfalarla doldur.
      // Bu sayede toggle açar açmaz kullanıcıya hazır liste gözükür; toggle kapalıyken
      // hiçbir şey görünmez (mevcut davranış korunur).
      const customNavEnableOverrides = isEnablingCustomNav
        ? (() => {
            const existing = prev.headerSettings.customNavMenu;
            const hasItems = Array.isArray(existing) && existing.length > 0;
            if (hasItems) return null;
            return { customNavMenu: [] };
          })()
        : null;

      const searchSyncOverrides =
        setting === 'searchType'
          ? { showSearch: value !== 'none' }
          : setting === 'showSearch'
            ? value === false
              ? { searchType: 'none' as const }
              : prev.headerSettings.searchType === 'none'
                ? { searchType: 'product' as const }
                : {}
            : {};

      const newConfig = {
        ...prev,
        headerSettings: {
          ...prev.headerSettings,
          [setting]: value,
          ...searchSyncOverrides,
          ...(isEnablingCustomNav && !nextCaps.inlineNav ? { enableCustomNavMenu: false } : {}),
          ...(headerTypeOverrides || {}),
          ...(customNavEnableOverrides || {}),
        },
        menuSettings:
          (isHeaderTypeChange && !nextCaps.separateMenu) || isHeaderEnabled
            ? {
                ...prev.menuSettings,
                ...(!nextCaps.separateMenu ? { enabled: false } : {}),
                ...(isHeaderEnabled ? { showMenuLeftLogo: false } : {}),
              }
            : prev.menuSettings,
      };

      const shouldSaveImmediately =
        setting === 'headerType' ||
        setting === 'header6AdvancedStyleEnabled' ||
        setting === 'menuAlign' ||
        setting === 'showPhoneButton' ||
        setting === 'showBranchesButton';

      // Kritik ayarlarda anında kaydet:
      // Kullanıcı hızlıca yenilerse debounce süresi dolmadan değişiklik kaybolmasın.
      if (shouldSaveImmediately) {
        if (headerSaveTimerRef.current) {
          clearTimeout(headerSaveTimerRef.current);
        }
        setTimeout(() => {
          autoSaveHeaderSettings(newConfig.headerSettings);
        }, 0);
      } else {
        // Diğer header ayarlarında debounce kullan
        if (headerSaveTimerRef.current) {
          clearTimeout(headerSaveTimerRef.current);
        }
        headerSaveTimerRef.current = setTimeout(() => {
          autoSaveHeaderSettings(newConfig.headerSettings);
        }, 1000); // 1 saniye bekle
      }

      // Menüyü kendi içinde taşıyan şablonlarda ayrı menü kaydı pasife çekilir
      if ((isHeaderTypeChange && !nextCaps.separateMenu) || isHeaderEnabled) {
        if (menuSaveTimerRef.current) {
          clearTimeout(menuSaveTimerRef.current);
        }
        menuSaveTimerRef.current = setTimeout(() => {
          autoSaveMenuSettings(
            newConfig.menuSettings,
            menuConfigIdRef.current || ecommerceConfigIdRef.current || config.id || null
          );
        }, 1000);
      }
      
      return newConfig;
    });
  };
  
  // Header ayarlarını otomatik kaydet
  const autoSaveHeaderSettings = async (headerSettings: any) => {
    console.log('🔍 [AUTO SAVE HEADER] === DETAYLI LOG BAŞLANGIÇ ===');
    console.log('🔍 [AUTO SAVE HEADER] companyId:', companyId);
    console.log('🔍 [AUTO SAVE HEADER] headerConfigId:', headerConfigId);
    console.log('🔍 [AUTO SAVE HEADER] headerSettings:', headerSettings);
    
    if (!companyId) {
      console.error('❌ [AUTO SAVE HEADER] CompanyId yok, kayıt atlanıyor');
      return;
    }
    
    // ✅ HeaderConfigId yoksa, ilk kayıt oluştur (companyId kullanarak)
    const effectiveConfigId = headerConfigId || companyId;
    
    if (!headerConfigId) {
      console.warn('⚠️ [AUTO SAVE HEADER] HeaderConfigId yok, ilk kayıt oluşturuluyor...');
      console.log('🆕 [AUTO SAVE HEADER] CompanyId kullanılarak ilk kayıt yapılacak:', companyId);
    }
    
    try {
      console.log('💾 [AUTO SAVE HEADER] Header ayarları otomatik kaydediliyor...');
      console.log('📋 [AUTO SAVE HEADER] Kullanılacak ConfigId:', effectiveConfigId);

      const headerSearchFields = getHeaderSearchSaveFields(
        headerSettings.searchType,
        headerSettings.showSearch
      );
      
      const headerData = {
        companyId: companyId,
        configId: effectiveConfigId, // ✅ HeaderConfigId yoksa companyId kullan
        headerStyle: headerSettings.headerType || 'header1', // ✅ headerType -> headerStyle
        showHeader: headerSettings.enabled !== undefined ? headerSettings.enabled : true, // ✅ Header açık/kapalı
        showTopBar: headerSettings.enabled !== undefined ? headerSettings.enabled : true, // ✅ Geriye dönük uyumluluk
        searchType: headerSearchFields.searchType,
        verticalPadding: headerSettings.verticalPadding || 16,
        backgroundColor: headerSettings.backgroundColor || '#ffffff',
        textColor: headerSettings.textColor || '#212121',
        logoUrl: headerSettings.logoUrl || undefined,
        logoWidth: headerSettings.logoWidth || 120,
        logoHeight: headerSettings.logoHeight || 50,
        logoAlign: headerSettings.logoAlign || 'left',
        mobileLogoUrl: headerSettings.mobileLogoUrl || undefined,
        showSearchBar: headerSearchFields.showSearchBar, // ✅ showSearch -> showSearchBar
        showUserMenu: headerSettings.showUserMenu !== undefined ? headerSettings.showUserMenu : true,
        showWishlist: headerSettings.showUserMenu !== undefined ? headerSettings.showUserMenu : true, // ✅ Favori ikonu için
        showCart: headerSettings.showCart !== undefined ? headerSettings.showCart : true,
        showUserIcon: headerSettings.showUserIcon !== undefined ? headerSettings.showUserIcon : true, // ✅ Kullanıcı ikonu için
        showMobileCategories: headerSettings.showMobileCategories !== undefined ? headerSettings.showMobileCategories : true, // ✅ Mobil kategoriler butonu
        showBecomeSellerButton: headerSettings.showBecomeSellerButton !== undefined ? headerSettings.showBecomeSellerButton : false, // ✅ "Bizimle Satıcı Ol" butonu
        showLanguageSwitcher: headerSettings.showBecomeSellerButton !== undefined ? headerSettings.showBecomeSellerButton : false, // ✅ DB uyumluluğu için
        showBottomNavbar: headerSettings.showBottomNavbar !== undefined ? headerSettings.showBottomNavbar : true,
        showHeaderInfoStrip: headerSettings.showHeaderInfoStrip === true,
        headerInfoStripText: headerSettings.headerInfoStripText ?? '',
        headerInfoStripBackgroundColor: headerSettings.headerInfoStripBackgroundColor || '#7ED957',
        headerInfoStripTextColor: headerSettings.headerInfoStripTextColor || '#111111',
        showHeaderMarqueeStrip: headerSettings.showHeaderMarqueeStrip === true,
        headerMarqueeStripText: headerSettings.headerMarqueeStripText ?? '',
        headerMarqueeStripBackgroundColor: headerSettings.headerMarqueeStripBackgroundColor || '#0f172a',
        headerMarqueeStripTextColor: headerSettings.headerMarqueeStripTextColor || '#ffffff',
        headerMarqueeSpeedSeconds: Number(headerSettings.headerMarqueeSpeedSeconds || 18),
        showLogo: headerSettings.showLogo !== false, // ✅ Logo göster
        cartIcon: headerSettings.cartIcon || 'cart-1',
        favoriteIcon: headerSettings.favoriteIcon || 'favorite-1',
        userIcon: headerSettings.userIcon || 'user-1',
        iconSize: headerSettings.iconSize || 24,
        header4Card1Enabled: headerSettings.header4Cards?.card1?.enabled !== undefined ? headerSettings.header4Cards.card1.enabled : true,
        header4Card1Text: headerSettings.header4Cards?.card1?.text || '',
        header4Card1BackgroundColor: headerSettings.header4Cards?.card1?.backgroundColor || '#ffffff',
        header4Card1TextColor: headerSettings.header4Cards?.card1?.textColor || '#212121',
        header4Card1IconUrl: headerSettings.header4Cards?.card1?.iconUrl || '',
        header4Card1LinkUrl: headerSettings.header4Cards?.card1?.linkUrl || '',
        header4Card2Enabled: headerSettings.header4Cards?.card2?.enabled !== undefined ? headerSettings.header4Cards.card2.enabled : true,
        header4Card2Text: headerSettings.header4Cards?.card2?.text || '',
        header4Card2BackgroundColor: headerSettings.header4Cards?.card2?.backgroundColor || '#ffffff',
        header4Card2TextColor: headerSettings.header4Cards?.card2?.textColor || '#212121',
        header4Card2IconUrl: headerSettings.header4Cards?.card2?.iconUrl || '',
        header4Card2LinkUrl: headerSettings.header4Cards?.card2?.linkUrl || '',
        header4CategoryBackgroundColor: headerSettings.header4CategoryBackgroundColor || '#ff8c00',
        header4CategoryTextColor: headerSettings.header4CategoryTextColor || '#ffffff',
        header4CategoryIcon: headerSettings.header4CategoryIcon || 'grid',
        header4CategoryText: headerSettings.header4CategoryText || 'Tüm Ürünlerimiz',
        header4CorporateIcon: headerSettings.header4CorporateIcon || 'none',
        // Header6 (Restoran/Brand) — kullanici tarafindan yonetilebilen ozel menu + siparis butonu
        enableCustomNavMenu: headerSettings.enableCustomNavMenu === true,
        customNavMenuJson: embedNavbarExtrasInMenuJson(
          JSON.stringify(
            Array.isArray(headerSettings.customNavMenu)
              ? normalizeCustomNavMenu(headerSettings.customNavMenu)
                  .slice()
                  .sort((a: any, b: any) => Number(a.order ?? 0) - Number(b.order ?? 0))
                  .map((it: any, idx: number) => {
                    const toPayload = (node: any, order: number): any => {
                      const children = Array.isArray(node?.children)
                        ? node.children
                            .slice()
                            .sort((a: any, b: any) => Number(a.order ?? 0) - Number(b.order ?? 0))
                            .map((child: any, childIndex: number) => toPayload(child, childIndex))
                        : [];

                      return {
                        id: String(node?.id || `nav_${order}_${Date.now()}`),
                        label: String(node?.label || ''),
                        url: String(node?.url || '/'),
                        order,
                        enabled: node?.enabled !== false,
                        openInNewTab: node?.openInNewTab === true,
                        children,
                      };
                    };

                    return toPayload(it, idx);
                  })
              : []
          ),
          resolveHeaderNavbarExtras(headerSettings)
        ),
        orderButtonIcon: headerSettings.orderButtonIcon || 'order-1',
        orderButtonText: headerSettings.orderButtonText || 'SİPARİŞ VER',
        orderButtonUrl: headerSettings.orderButtonUrl || '/cart',
        orderButtonBackgroundColor: headerSettings.orderButtonBackgroundColor || '#e63946',
        orderButtonTextColor: headerSettings.orderButtonTextColor || '#ffffff',
        showOrderButton: headerSettings.showOrderButton === true,
        header6AdvancedStyleEnabled: headerSettings.header6AdvancedStyleEnabled === true,
        header6LogoAlign: headerSettings.header6LogoAlign || 'left',
        header6MenuFontSize: Number(headerSettings.header6MenuFontSize || 14),
        header6MenuFontWeight: Number(headerSettings.header6MenuFontWeight || 700),
        header6MenuTextTransform: headerSettings.header6MenuTextTransform || 'uppercase',
        header6MenuItalic: headerSettings.header6MenuItalic === true,
        header6MenuFontFamily: headerSettings.header6MenuFontFamily || 'Inter, sans-serif',
        header6MenuItemColor: headerSettings.header6MenuItemColor || '#ffffff',
        header6MenuLetterSpacing: Number(headerSettings.header6MenuLetterSpacing ?? 0.6),
        ...resolveHeaderNavbarExtras(headerSettings),
      };
      
      console.log('📤 [AUTO SAVE HEADER] Backend e gönderilen veri:', headerData);
      
      const response = await saveHeaderConfig(headerData);
      console.log('✅ [AUTO SAVE HEADER] Header ayarları otomatik kaydedildi');
      console.log('📥 [AUTO SAVE HEADER] Backend yanıtı:', response);
      notifyEcommerceSaved(t('ecommerceGeneral.autoSave.savedToast'));
      
      // ✅ İlk kayıt sonrası ID'yi set et
      if (!headerConfigId && response && response.data && response.data.id) {
        console.log('🆕 [AUTO SAVE HEADER] İlk kayıt yapıldı, HeaderConfigId set ediliyor:', response.data.id);
        setHeaderConfigId(response.data.id);
      }
    } catch (error: any) {
      console.error('❌ [AUTO SAVE HEADER] Otomatik kayıt hatası:', error);
      console.error('❌ [AUTO SAVE HEADER] Hata detayı:', error.response?.data || error.message);
    }
    
    console.log('🔍 [AUTO SAVE HEADER] === DETAYLI LOG BİTİŞ ===');
  };

  // Logo kütüphanesi modalını aç
  const handleOpenLogoLibrary = (type: 'desktop' | 'mobile' | 'menu') => {
    setLogoType(type);
    setIsLogoLibraryModalOpen(true);
  };

  // Logo kütüphanesi modalını kapat
  const handleCloseLogoLibrary = () => {
    setIsLogoLibraryModalOpen(false);
  };

  // Logo kaldırma fonksiyonu
  const handleRemoveLogo = () => {
    console.log('🗑️ [LOGO] Logo kaldırılıyor...');
    
    setConfig(prev => {
      const newConfig = {
        ...prev,
        headerSettings: {
          ...prev.headerSettings,
          logoUrl: undefined
        }
      };
      
      // Otomatik kaydet
      setTimeout(() => {
        autoSaveHeaderSettings(newConfig.headerSettings);
      }, 100);
      
      return newConfig;
    });
    
    setCurrentLogoUrl(null);
    console.log('✅ [LOGO] Logo başarıyla kaldırıldı');
  };

  const handleOpenMenuLogoLibrary = () => {
    handleOpenLogoLibrary('menu');
  };

  const handleRemoveMenuLogo = () => {
    handleRemoveLogo();
  };

  // Logo seçildiğinde kaydet
  // İkon seçimi modal handler'ları
  const handleOpenIconModal = (cardType: 'card1' | 'card2', category: 'phone' | 'cart') => {
    setIconModalCardType(cardType);
    setIconModalCategory(category);
    setIsIconModalOpen(true);
  };

  const handleCloseIconModal = () => {
    setIsIconModalOpen(false);
  };

  const handleSaveIcon = (iconType: string) => {
    console.log('🎨 [ICON] İkon seçildi:', iconType, 'Kart:', iconModalCardType);
    
    // State'i güncelle
    setConfig(prev => {
      const currentCards = prev.headerSettings.header4Cards || {
        card1: { enabled: true, text: '', backgroundColor: '#ffffff', textColor: '#212121', iconUrl: '', linkUrl: '' },
        card2: { enabled: true, text: '', backgroundColor: '#ffffff', textColor: '#212121', iconUrl: '', linkUrl: '' }
      };

      const currentCard = currentCards[iconModalCardType] || {
        enabled: true,
        text: '',
        backgroundColor: '#ffffff',
        textColor: '#212121',
        iconUrl: '',
        linkUrl: ''
      };

      const newConfig = {
        ...prev,
        headerSettings: {
          ...prev.headerSettings,
          header4Cards: {
            ...currentCards,
            [iconModalCardType]: {
              ...currentCard,
              iconUrl: iconType
            }
          }
        }
      };
      
      // Otomatik kaydet
      setTimeout(() => {
        autoSaveHeaderSettings(newConfig.headerSettings);
      }, 100);
      
      return newConfig;
    });

    console.log('✅ [ICON] İkon başarıyla kaydedildi');
  };

  const handleSaveLogoFromLibrary = async (selectedUrls: string[]) => {
    if (selectedUrls.length === 0) {
      console.warn('⚠️ [LOGO] Resim seçilmedi');
      return;
    }

    const selectedLogoUrl = selectedUrls[0]; // İlk resmi al
    console.log('🖼️ [LOGO] Seçilen logo:', selectedLogoUrl, 'Tip:', logoType);

    try {
      // State'i güncelle ve otomatik kaydet
      setConfig(prev => {
        const logoField = logoType === 'mobile' ? 'mobileLogoUrl' : 'logoUrl';
        const newConfig = {
          ...prev,
          headerSettings: {
            ...prev.headerSettings,
            [logoField]: selectedLogoUrl
          }
        };
        
        // Otomatik kaydet
        setTimeout(() => {
          autoSaveHeaderSettings(newConfig.headerSettings);
        }, 100);
        
        return newConfig;
      });
      
      if (logoType !== 'mobile') {
        setCurrentLogoUrl(selectedLogoUrl);
      }
      
      console.log('✅ [LOGO] Logo başarıyla kaydedildi');
    } catch (error) {
      console.error('❌ [LOGO] Logo kaydetme hatası:', error);
    }
  };

  // Header Type değişikliğini SQL'e kaydet
  const saveHeaderTypeToSQL = async () => {
    if (!companyId) {
      setError("Şirket ID bulunamadı.");
      return;
    }
    
    setIsSaving(true);
    setError(null);
    
    try {
      console.log('💾 [SAVE HEADER] Header ayarları SQL e kaydediliyor:', {
        companyId,
        headerType: config.headerSettings.headerType,
        searchType: config.headerSettings.searchType,
        verticalPadding: config.headerSettings.verticalPadding,
        backgroundColor: config.headerSettings.backgroundColor,
        textColor: config.headerSettings.textColor,
        showSearch: config.headerSettings.showSearch,
        showCart: config.headerSettings.showCart,
        showUserMenu: config.headerSettings.showUserMenu,
        logoUrl: config.headerSettings.logoUrl,
        logoWidth: config.headerSettings.logoWidth,
        mobileLogoUrl: config.headerSettings.mobileLogoUrl,
        favoriteIcon: config.headerSettings.favoriteIcon,
        cartIcon: config.headerSettings.cartIcon,
        userIcon: config.headerSettings.userIcon,
        iconSize: config.headerSettings.iconSize,
        headerConfigId
      });
      
      const headerSearchFields = getHeaderSearchSaveFields(
        config.headerSettings.searchType,
        config.headerSettings.showSearch
      );

      const headerData = {
        companyId: companyId,
        configId: companyId, // Her şirkete bir config
        headerStyle: config.headerSettings.headerType, // headerType -> headerStyle
        showHeader: config.headerSettings.enabled !== undefined ? config.headerSettings.enabled : true, // Header açık/kapalı
        showTopBar: config.headerSettings.enabled !== undefined ? config.headerSettings.enabled : true, // Geriye dönük uyumluluk
        searchType: headerSearchFields.searchType, // Arama tipi
        verticalPadding: config.headerSettings.verticalPadding || 16, // Header dikey boşluk
        backgroundColor: config.headerSettings.backgroundColor || '#ffffff', // Header arka plan rengi
        textColor: config.headerSettings.textColor || '#212121', // Header yazı rengi
        showSearchBar: headerSearchFields.showSearchBar, // Arama çubuğunu göster
        showCart: config.headerSettings.showCart !== undefined ? config.headerSettings.showCart : true, // Sepet ikonunu göster
        showUserMenu: config.headerSettings.showUserMenu !== undefined ? config.headerSettings.showUserMenu : true, // Favori/Kullanıcı menüsünü göster
        showUserIcon: config.headerSettings.showUserIcon !== undefined ? config.headerSettings.showUserIcon : true,
        showWishlist: config.headerSettings.showUserMenu !== undefined ? config.headerSettings.showUserMenu : true,
        ...resolveHeaderNavbarExtras(config.headerSettings),
        customNavMenuJson: embedNavbarExtrasInMenuJson(
          JSON.stringify(
            Array.isArray(config.headerSettings.customNavMenu)
              ? normalizeCustomNavMenu(config.headerSettings.customNavMenu)
              : []
          ),
          resolveHeaderNavbarExtras(config.headerSettings)
        ),
        showBecomeSellerButton: config.headerSettings.showBecomeSellerButton !== undefined ? config.headerSettings.showBecomeSellerButton : false, // "Bizimle Satıcı Ol" butonu
        showLanguageSwitcher: config.headerSettings.showBecomeSellerButton !== undefined ? config.headerSettings.showBecomeSellerButton : false, // DB uyumluluğu için
        logoUrl: config.headerSettings.logoUrl || null, // ✅ Logo URL
        logoWidth: config.headerSettings.logoWidth || 120, // ✅ Logo genişliği
        logoHeight: config.headerSettings.logoHeight || 50, // ✅ Logo yüksekliği
        logoAlign: config.headerSettings.logoAlign || 'left', // ✅ Logo hizası
        mobileLogoUrl: config.headerSettings.mobileLogoUrl || null, // ✅ Mobil logo URL
        favoriteIcon: config.headerSettings.favoriteIcon || 'favorite-1', // ✅ Favori ikonu
        cartIcon: config.headerSettings.cartIcon || 'cart-1', // ✅ Sepet ikonu
        userIcon: config.headerSettings.userIcon || 'user-1', // ✅ Kullanıcı ikonu
        iconSize: config.headerSettings.iconSize || 24, // ✅ İkon boyutu
        // Header4 Kartlar
        header4Card1Enabled: config.headerSettings.header4Cards?.card1.enabled !== undefined ? config.headerSettings.header4Cards.card1.enabled : true,
        header4Card1Text: config.headerSettings.header4Cards?.card1.text || null,
        header4Card1BackgroundColor: config.headerSettings.header4Cards?.card1.backgroundColor || null,
        header4Card1TextColor: config.headerSettings.header4Cards?.card1.textColor || null,
        header4Card1IconUrl: config.headerSettings.header4Cards?.card1.iconUrl || null,
        header4Card1LinkUrl: config.headerSettings.header4Cards?.card1.linkUrl || null,
        header4Card2Enabled: config.headerSettings.header4Cards?.card2.enabled !== undefined ? config.headerSettings.header4Cards.card2.enabled : true,
        header4Card2Text: config.headerSettings.header4Cards?.card2.text || null,
        header4Card2BackgroundColor: config.headerSettings.header4Cards?.card2.backgroundColor || null,
        header4Card2TextColor: config.headerSettings.header4Cards?.card2.textColor || null,
        header4Card2IconUrl: config.headerSettings.header4Cards?.card2.iconUrl || null,
        header4Card2LinkUrl: config.headerSettings.header4Cards?.card2.linkUrl || null,
        header4CategoryBackgroundColor: config.headerSettings.header4CategoryBackgroundColor || '#ff8c00',
        header4CategoryTextColor: config.headerSettings.header4CategoryTextColor || '#ffffff',
        header4CategoryIcon: config.headerSettings.header4CategoryIcon || 'grid',
        header4CategoryText: config.headerSettings.header4CategoryText || 'Tüm Ürünlerimiz',
        header4CorporateIcon: config.headerSettings.header4CorporateIcon || 'none',
      };
      
      const response = await saveHeaderConfig(headerData);
      console.log("✅ [SAVE HEADER] Header ayarları başarıyla kaydedildi:", response);
      
      // Başarılı kayıt sonrası ID'yi güncelle
      if (response && response.data && response.data.id) {
        setHeaderConfigId(response.data.id);
      }
    } catch (error: any) {
      console.error("❌ [SAVE HEADER] Header ayarları kaydedilirken hata:", error);
      setError(error.response?.data?.message || "Header ayarları kaydedilirken bir hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };
  
  // Menu ayarlarını SQL'e kaydet
  const saveMenuSettingsToSQL = async () => {
    if (!companyId) {
      setError("Şirket ID bulunamadı.");
      return;
    }
    
    setIsSaving(true);
    setError(null);
    
    try {
      console.log('💾 [SAVE MENU] Menu ayarları SQL e kaydediliyor:', {
        companyId,
        enabled: config.menuSettings.enabled,
        menuType: config.menuSettings.menuType,
        menuPosition: config.menuSettings.menuPosition,
        verticalPadding: config.menuSettings.verticalPadding,
        backgroundColor: config.menuSettings.backgroundColor,
        textColor: config.menuSettings.textColor,
        textTransform: config.menuSettings.textTransform,
        showAllCategories: config.menuSettings.showAllCategories,
        showHomePage: config.menuSettings.showHomePage,
        corporateNavDisplayMode: config.menuSettings.corporateNavDisplayMode || 'dropdown',
        showQuoteButton: config.menuSettings.showQuoteButton,
        quoteButtonTitle: config.menuSettings.quoteButtonTitle,
        quoteButtonSubtitle: config.menuSettings.quoteButtonSubtitle,
        quoteButtonLink: config.menuSettings.quoteButtonLink,
        showMenuLeftLogo: config.menuSettings.showMenuLeftLogo,
        menuConfigId
      });
      
      // ConfigId'yi SQL'den alınan menuConfigId'den al
      if (!menuConfigId) {
        setError("Menu Config ID bulunamadı. Lütfen sayfayı yenileyin.");
        return;
      }
      
      const menuData = {
        companyId: companyId,
        configId: menuConfigId, // SQL'den gelen EcommerceConfig ID'si
        enabled: config.menuSettings.enabled !== undefined ? config.menuSettings.enabled : true,
        menuType: config.menuSettings.menuType || 'menu1',
        menuPosition: config.menuSettings.menuPosition || 'center',
        verticalPadding: config.menuSettings.verticalPadding || 12,
        backgroundColor: config.menuSettings.backgroundColor || '#ffffff',
        textColor: config.menuSettings.textColor || '#111827',
        textTransform: config.menuSettings.textTransform || 'none',
        enableMegaMenu: config.menuSettings.directCategoryLinks === true,
        menuStyle: config.menuSettings.menuItemSource === 'brands' ? 'brands' : 'horizontal',
        showAllCategories: config.menuSettings.showAllCategories !== undefined ? config.menuSettings.showAllCategories : true,
        showHomePage: config.menuSettings.showHomePage !== undefined ? config.menuSettings.showHomePage : true,
        corporateNavDisplayMode: config.menuSettings.corporateNavDisplayMode || 'dropdown',
        corporateSidebarLayoutMode:
          config.menuSettings.corporateSidebarLayoutMode === 'below_navbar' ? 'below_navbar' : 'below_hero',
        corporateSidebarSettingsJson: serializeCorporateSidebarSettingsJson(
          config.menuSettings.corporateSidebarSettings || {},
          config.menuSettings.corporateSidebarLayoutMode === 'below_navbar' ? 'below_navbar' : 'below_hero'
        ),
        showQuoteButton: config.menuSettings.showQuoteButton === true,
        quoteButtonTitle: config.menuSettings.quoteButtonTitle || 'Teklif Al',
        quoteButtonSubtitle: config.menuSettings.quoteButtonSubtitle || 'Hemen arayın, size özel teklif hazırlayalım',
        quoteButtonLink: config.menuSettings.quoteButtonLink || '/contact',
        showDropdownIcons: config.menuSettings.showMenuLeftLogo !== undefined ? config.menuSettings.showMenuLeftLogo : false,
      };
      
      const response = await saveMenuConfig(menuData);
      console.log("✅ [SAVE MENU] Menu ayarları başarıyla kaydedildi:", response);
      
      // Başarılı kayıt sonrası ID'yi güncelle
      if (response && response.data && response.data.id) {
        setMenuConfigId(response.data.id);
      }
    } catch (error: any) {
      console.error("❌ [SAVE MENU] Menu ayarları kaydedilirken hata:", error);
      setError(error.response?.data?.message || "Menu ayarları kaydedilirken bir hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  // Slider ayarları değişikliği
  const handleSliderSettingChange = (
    setting: 'enabled' | 'autoplay' | 'interval' | 'slides' | 'title' | 'description' | 'background' | 'textPosition' | 'textAlign' | 'textAnimation' | 'textMode' | 'textSlideId' | 'height' | 'bottomDarken' | 'imageBlur' | 'textInset' | 'showTrustStrip' | 'trustStripSettings', 
    value: any
  ) => {
    if (!config) return;
    setConfig(prev => ({
      ...prev,
      sliderSettings: {
        ...prev.sliderSettings,
        [setting]: value
      }
    }));
  };

  // Kategori ayarları değişikliği
  const handleCategorySettingChange = (setting: keyof EcommerceConfig['categorySettings'], value: any) => {
    setConfig(prev => ({ ...prev, categorySettings: { ...prev.categorySettings, [setting]: value } }));
  };

  // Ürün ayarları değişikliği
  const handleProductSettingChange = (setting: keyof typeof config.productSettings, value: any) => {
    setConfig(prev => ({ ...prev, productSettings: { ...prev.productSettings, [setting]: value } }));
  };

  const handleProductDisplaySettingChange = (setting: keyof EcommerceConfig['productDisplaySettings'], value: any) => {
    setConfig(prev => ({ ...prev, productDisplaySettings: { ...prev.productDisplaySettings, [setting]: value } }));
  };

  // Footer ayarları değişikliği
  const handleFooterSettingChange = (setting: keyof typeof config.footerSettings, value: any) => {
    setConfig(prev => ({ ...prev, footerSettings: { ...prev.footerSettings, [setting]: value } }));
  };

  // Menü ayarları değişikliği (otomatik kayıt ile)
  const handleMenuSettingChange = (setting: keyof typeof config.menuSettings, value: any) => {
    if (
      setting === 'enabled' &&
      Boolean(value) &&
      !getHeaderTemplate(config.headerSettings?.headerType).capabilities.separateMenu
    ) {
      return;
    }

    // State'i güncelle
    setConfig(prev => {
      const newConfig = {
      ...prev,
      menuSettings: {
        ...prev.menuSettings,
        [setting]: value,
        ...(setting === 'corporateSidebarLayoutMode'
          ? {
              corporateSidebarSettings: {
                ...(prev.menuSettings.corporateSidebarSettings || {}),
                layoutMode: value === 'below_navbar' ? 'below_navbar' : 'below_hero',
              },
            }
          : {}),
      }
      };
      
      // moduleType değişikliği için özel işlem (EcommerceConfig'e kaydet)
      if (setting === 'moduleType') {
        // Otomatik kayıt için debounce timer başlat
        if (menuSaveTimerRef.current) {
          clearTimeout(menuSaveTimerRef.current);
        }
        
        menuSaveTimerRef.current = setTimeout(() => {
          autoSaveHomePageModuleStyle(value);
        }, 1000); // 1 saniye bekle
      } else {
        // Diğer menu ayarları için normal kayıt
        if (menuSaveTimerRef.current) {
          clearTimeout(menuSaveTimerRef.current);
        }
        
        menuSaveTimerRef.current = setTimeout(() => {
          autoSaveMenuSettings(
            newConfig.menuSettings,
            menuConfigIdRef.current || ecommerceConfigIdRef.current || config.id || null
          );
        }, 1000); // 1 saniye bekle
      }
      
      return newConfig;
    });
  };
  
  // Menu ayarlarını otomatik kaydet
  const autoSaveMenuSettings = async (menuSettings: any, configIdOverride?: string | null) => {
    const resolvedConfigId =
      configIdOverride || menuConfigIdRef.current || ecommerceConfigIdRef.current || config.id || null;

    if (!companyId || !resolvedConfigId) {
      console.log('⏭️ [AUTO SAVE MENU] CompanyId veya ConfigId yok, kayıt atlanıyor', {
        companyId,
        configId: resolvedConfigId,
      });
      return;
    }
    
    try {
      console.log('💾 [AUTO SAVE MENU] Menu ayarları otomatik kaydediliyor...');
      
      const menuData = {
        companyId: companyId,
        configId: resolvedConfigId,
        enabled: menuSettings.enabled !== undefined ? menuSettings.enabled : true,
        menuType: menuSettings.menuType || 'menu1',
        menuPosition: menuSettings.menuPosition || 'center',
        verticalPadding: menuSettings.verticalPadding || 12,
        backgroundColor: menuSettings.backgroundColor || '#ffffff',
        textColor: menuSettings.textColor || '#111827',
        textTransform: menuSettings.textTransform || 'none',
        enableMegaMenu: menuSettings.directCategoryLinks === true,
        menuStyle: menuSettings.menuItemSource === 'brands' ? 'brands' : 'horizontal',
        showAllCategories: menuSettings.showAllCategories !== undefined ? menuSettings.showAllCategories : true,
        showHomePage: menuSettings.showHomePage !== undefined ? menuSettings.showHomePage : true,
        corporateNavDisplayMode: menuSettings.corporateNavDisplayMode || 'dropdown',
        corporateSidebarLayoutMode:
          menuSettings.corporateSidebarLayoutMode === 'below_navbar' ? 'below_navbar' : 'below_hero',
        corporateSidebarSettingsJson: serializeCorporateSidebarSettingsJson(
          menuSettings.corporateSidebarSettings || {},
          menuSettings.corporateSidebarLayoutMode === 'below_navbar' ? 'below_navbar' : 'below_hero'
        ),
        showQuoteButton: menuSettings.showQuoteButton === true,
        quoteButtonTitle: menuSettings.quoteButtonTitle || 'Teklif Al',
        quoteButtonSubtitle: menuSettings.quoteButtonSubtitle || 'Hemen arayın, size özel teklif hazırlayalım',
        quoteButtonLink: menuSettings.quoteButtonLink || '/contact',
        showDropdownIcons: menuSettings.showMenuLeftLogo !== undefined ? menuSettings.showMenuLeftLogo : false,
      };
      
      await saveMenuConfig(menuData);
      console.log('✅ [AUTO SAVE MENU] Menu ayarları otomatik kaydedildi');
      notifyEcommerceSaved(t('ecommerceGeneral.autoSave.savedToast'));
    } catch (error) {
      console.error('❌ [AUTO SAVE MENU] Otomatik kayıt hatası:', error);
    }
  };
  
  // Ana Sayfa Modül Stilini otomatik kaydet (EcommerceConfig'e)
  const autoSaveHomePageModuleStyle = async (moduleStyle: string) => {
    if (!companyId) {
      console.log('⏭️ [AUTO SAVE HOMEPAGE] CompanyId yok, kayıt atlanıyor');
      return;
    }
    
    try {
      console.log('💾 [AUTO SAVE HOMEPAGE] Ana sayfa modül stili otomatik kaydediliyor:', moduleStyle);
      
      const configData = {
        companyId: companyId,
        homePageModuleStyle: moduleStyle
      };
      
      await saveGeneralConfig(configData);
      console.log('✅ [AUTO SAVE HOMEPAGE] Ana sayfa modül stili otomatik kaydedildi');
      notifyEcommerceSaved(t('ecommerceGeneral.autoSave.savedToast'));
    } catch (error) {
      console.error('❌ [AUTO SAVE HOMEPAGE] Otomatik kayıt hatası:', error);
    }
  };

  const whyChooseFeatureText = (
    settings: any,
    index: number,
    field: 'title' | 'description'
  ): string | undefined => {
    const features = settings?.whyChooseSection?.features;
    if (!Array.isArray(features)) return undefined;
    return features[index]?.[field] ?? '';
  };

  const autoSaveAboutSettings = async (settings: any) => {
    if (!companyId) {
      console.warn('⚠️ [AUTO SAVE ABOUT] CompanyId bulunamadı, kayıt atlanıyor');
      return;
    }

    if (!ecommerceConfigId && !config.id) {
      console.warn('⚠️ [AUTO SAVE ABOUT] ConfigId bulunamadı, kayıt atlanıyor');
      return;
    }

    try {
      const configIdToUse = ecommerceConfigId || config.id || '';
      const heroSection = settings.heroSection || defaultCorporateHeroSectionSettings;

      const requestData = {
        companyId: companyId,
        configId: configIdToUse,
        ...buildCorporateHeroSavePayload(heroSection),
        storyTitle: settings.storySection?.title,
        storyDescription: settings.storySection?.description,
        storyBackgroundColor: settings.storySection?.backgroundColor,
        storyStatCustomers: settings.storySection?.stats?.customers,
        storyStatProducts: settings.storySection?.stats?.products,
        storyStatSupport: settings.storySection?.stats?.support,
        storyStatSatisfaction: settings.storySection?.stats?.satisfaction,
        valuesTitle: settings.valuesSection?.title,
        valuesDescription: settings.valuesSection?.description,
        valuesBackgroundColor: settings.valuesSection?.backgroundColor,
        value1Title: settings.valuesSection?.values?.[0]?.title ?? '',
        value1Description: settings.valuesSection?.values?.[0]?.description ?? '',
        value1Icon: settings.valuesSection?.values?.[0]?.icon ?? '',
        value1Color: settings.valuesSection?.values?.[0]?.color ?? '',
        value2Title: settings.valuesSection?.values?.[1]?.title ?? '',
        value2Description: settings.valuesSection?.values?.[1]?.description ?? '',
        value2Icon: settings.valuesSection?.values?.[1]?.icon ?? '',
        value2Color: settings.valuesSection?.values?.[1]?.color ?? '',
        value3Title: settings.valuesSection?.values?.[2]?.title ?? '',
        value3Description: settings.valuesSection?.values?.[2]?.description ?? '',
        value3Icon: settings.valuesSection?.values?.[2]?.icon ?? '',
        value3Color: settings.valuesSection?.values?.[2]?.color ?? '',
        value4Title: settings.valuesSection?.values?.[3]?.title ?? '',
        value4Description: settings.valuesSection?.values?.[3]?.description ?? '',
        value4Icon: settings.valuesSection?.values?.[3]?.icon ?? '',
        value4Color: settings.valuesSection?.values?.[3]?.color ?? '',
        value5Title: settings.valuesSection?.values?.[4]?.title ?? '',
        value5Description: settings.valuesSection?.values?.[4]?.description ?? '',
        value5Icon: settings.valuesSection?.values?.[4]?.icon ?? '',
        value5Color: settings.valuesSection?.values?.[4]?.color ?? '',
        value6Title: settings.valuesSection?.values?.[5]?.title ?? '',
        value6Description: settings.valuesSection?.values?.[5]?.description ?? '',
        value6Icon: settings.valuesSection?.values?.[5]?.icon ?? '',
        value6Color: settings.valuesSection?.values?.[5]?.color ?? '',
        whyChooseTitle: settings.whyChooseSection?.title,
        whyChooseDescription: settings.whyChooseSection?.description,
        whyChooseBackgroundColor: settings.whyChooseSection?.backgroundColor,
        feature1Title: whyChooseFeatureText(settings, 0, 'title'),
        feature1Description: whyChooseFeatureText(settings, 0, 'description'),
        feature2Title: whyChooseFeatureText(settings, 1, 'title'),
        feature2Description: whyChooseFeatureText(settings, 1, 'description'),
        feature3Title: whyChooseFeatureText(settings, 2, 'title'),
        feature3Description: whyChooseFeatureText(settings, 2, 'description'),
        feature4Title: whyChooseFeatureText(settings, 3, 'title'),
        feature4Description: whyChooseFeatureText(settings, 3, 'description'),
        feature5Title: whyChooseFeatureText(settings, 4, 'title'),
        feature5Description: whyChooseFeatureText(settings, 4, 'description'),
        feature6Title: whyChooseFeatureText(settings, 5, 'title'),
        feature6Description: whyChooseFeatureText(settings, 5, 'description'),
        sectionSettingsJson: settings.sectionSettingsJson || serializeSectionSettingsJson(settings.sectionSettings || {}),
      };

      await saveAboutSettings(requestData);
      notifyEcommerceSaved(t('ecommerceGeneral.autoSave.savedToast'));
    } catch (error) {
      console.error('❌ [AUTO SAVE ABOUT] Otomatik kayıt hatası:', error);
    }
  };

  // Yeni ayarlar için handler fonksiyonları
  const handleAboutSettingsChange = (settings: any) => {
    setConfig(prev => ({
      ...prev,
      aboutSettings: settings
    }));

    if (aboutSaveTimerRef.current) {
      clearTimeout(aboutSaveTimerRef.current);
    }

    aboutSaveTimerRef.current = setTimeout(() => {
      void autoSaveAboutSettings(settings);
    }, 1000);
  };

  const handleServiceSettingsChange = async (settings: any) => {
    // Local state'i güncelle
    setConfig(prev => ({
      ...prev,
      serviceSettings: settings
    }));

    // SQL'e otomatik kaydet
    try {
      console.log('💾 [SERVICE SETTINGS] Auto-saving to SQL...');
      // Bu fonksiyon OurServicessettings.tsx içinde kendi API çağrısını yapacak
      // Burada sadece local state güncelleniyor
    } catch (error) {
      console.error('❌ [SERVICE SETTINGS] Auto-save error:', error);
    }
  };

  const handleContactSettingsChange = (settings: any) => {
    setConfig(prev => ({
      ...prev,
      contactSettings: settings
    }));
  };

  const handleRestaurantSettingsChange = (settings: any) => {
    setConfig(prev => ({
      ...prev,
      restaurantsSettings: settings
    }));
  };

  const handleReferencesSettingsChange = (settings: any) => {
    setConfig(prev => ({
      ...prev,
      referencesSettings: settings
    }));
  };

  const handleFaqSettingsChange = (settings: any) => {
    setConfig(prev => ({
      ...prev,
      faqSettings: settings
    }));
  };

  const handleCartSettingsChange = (settings: any) => {
    setConfig(prev => ({
      ...prev,
      cartSettings: settings
    }));
  };

  const handleProductSolutionSettingsChange = (settings: any) => {
    // Local state'i güncelle (otomatik kayıt ProductSolutionSettingsComponent içinde yapılıyor)
    setConfig(prev => ({
      ...prev,
      productSolutionSettings: settings
    }));
  };

  const handleFooterSettingsDetailedChange = (settings: any) => {
    setConfig(prev => ({
      ...prev,
      footerSettingsDetailed: settings
    }));
  };

  const handleSiteBackgroundSettingsChange = (setting: keyof EcommerceConfig['siteBackgroundSettings'], value: any) => {
    setConfig(prev => ({
      ...prev,
      siteBackgroundSettings: {
        ...prev.siteBackgroundSettings,
        [setting]: value
      }
    }));
  };

  const handleLogoFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      // Dosya boyutu kontrolü (5MB)
      if (file.size > 5 * 1024 * 1024) {
        setError("Logo boyutu 5MB'dan büyük olamaz.");
        return;
      }
      setLogoFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleLogoUpload = async () => {
    if (!logoFile || !companyId) {
      setError("Lütfen bir logo dosyası seçin.");
      return;
    }
    
    setIsUploadingLogo(true);
    setError(null);
  
    try {
      // Firebase Storage'da bir referans oluştur
      const logoPath = `companies/${companyId}/logo/${Date.now()}_${logoFile.name}`;
      const logoStorageReference = storageRef(storage, logoPath);

      // Dosyayı yükle
      await uploadBytes(logoStorageReference, logoFile);

      // İndirme URL'sini al
      const downloadURL = await getDownloadURL(logoStorageReference);
      
      // Logo URL'sini SQL Company.LogoUrl'e yaz (DAIMA SQL).
      await updateCompanyInfo(companyId, { logoUrl: downloadURL });

      // Başarılı yüklemeden sonra state'i temizle
      setLogoFile(null);
      setLogoPreview(null);
  
    } catch (err: any) {
      console.error("Firebase logo yükleme hatası:", err);
      setError(err.message || "Logo yüklenirken bir hata oluştu.");
    } finally {
      setIsUploadingLogo(false);
    }
  };

  // Kategori görünürlüğünü değiştir
  const toggleCategoryVisibility = (categoryId: string) => {
    const updateVisibility = (categories: MenuCategory[]): MenuCategory[] => {
      return categories.map(category => {
        if (category.id === categoryId) {
          return {
            ...category,
            visible: !category.visible
          };
        }
        
        if (category.subCategories && category.subCategories.length > 0) {
          return {
            ...category,
            subCategories: updateVisibility(category.subCategories)
          };
        }
        
        return category;
      });
    };

    setConfig(prev => ({
      ...prev,
      menuCategories: updateVisibility(prev.menuCategories)
    }));
  };

  // Kategoriyi yukarı taşı
  const moveCategoryUp = (index: number, parentCategories?: MenuCategory[]) => {
    if (index === 0) return;

    const categories = parentCategories || config.menuCategories;
    const updatedCategories = [...categories];
    const temp = updatedCategories[index];
    updatedCategories[index] = updatedCategories[index - 1];
    updatedCategories[index - 1] = temp;

    // Sıralama numaralarını güncelle
    const reorderedCategories = updatedCategories.map((category, idx) => ({
      ...category,
      order: idx
    }));

    if (parentCategories) {
      // Alt kategori sıralaması değişti, ana kategorileri rekürsif olarak güncelle
      const updateParentCategories = (allCategories: MenuCategory[], targetParent: MenuCategory[]): MenuCategory[] => {
        return allCategories.map(category => {
          if (category.subCategories && category.subCategories.some(sc => targetParent.some(tp => tp.id === sc.id))) {
            return {
              ...category,
              subCategories: reorderedCategories
            };
          }
          
          if (category.subCategories && category.subCategories.length > 0) {
            return {
              ...category,
              subCategories: updateParentCategories(category.subCategories, targetParent)
            };
          }
          
          return category;
        });
      };
      
      setConfig(prev => ({
        ...prev,
        menuCategories: updateParentCategories(prev.menuCategories, parentCategories)
      }));
    } else {
      // Ana kategori sıralaması değişti
      setConfig(prev => ({
        ...prev,
        menuCategories: reorderedCategories
      }));
    }
  };

  // Kategoriyi aşağı taşı
  const moveCategoryDown = (index: number, parentCategories?: MenuCategory[]) => {
    const categories = parentCategories || config.menuCategories;
    if (index === categories.length - 1) return;

    const updatedCategories = [...categories];
    const temp = updatedCategories[index];
    updatedCategories[index] = updatedCategories[index + 1];
    updatedCategories[index + 1] = temp;

    // Sıralama numaralarını güncelle
    const reorderedCategories = updatedCategories.map((category, idx) => ({
      ...category,
      order: idx
    }));

    if (parentCategories) {
      // Alt kategori sıralaması değişti, ana kategorileri rekürsif olarak güncelle
      const updateParentCategories = (allCategories: MenuCategory[], targetParent: MenuCategory[]): MenuCategory[] => {
        return allCategories.map(category => {
          if (category.subCategories && category.subCategories.some(sc => targetParent.some(tp => tp.id === sc.id))) {
            return {
              ...category,
              subCategories: reorderedCategories
            };
          }
          
          if (category.subCategories && category.subCategories.length > 0) {
            return {
              ...category,
              subCategories: updateParentCategories(category.subCategories, targetParent)
            };
          }
          
          return category;
        });
      };
      
      setConfig(prev => ({
        ...prev,
        menuCategories: updateParentCategories(prev.menuCategories, parentCategories)
      }));
    } else {
      // Ana kategori sıralaması değişti
      setConfig(prev => ({
        ...prev,
        menuCategories: reorderedCategories
      }));
    }
  };

  // Kategori resmi yükleme butonuna tıklama
  const handleCategoryImageButtonClick = (categoryId: string) => {
    if (!companyId) {
      setError("Şirket ID bulunamadı. Resim yüklenemez.");
      return;
    }
    setCurrentCategoryId(categoryId);
    setImageUploadType('category');
    setCategoryImageModalOpen(true);
  };

  // Sayfa üst resmi yükleme butonuna tıklama
  const handleCategoryHeaderImageButtonClick = (categoryId: string) => {
    if (!companyId) {
      setError("Şirket ID bulunamadı. Resim yüklenemez.");
      return;
    }
    setCurrentCategoryId(categoryId);
    setImageUploadType('header');
    setCategoryImageModalOpen(true);
  };

  // Seçilen kategori resmini yükle (Storage + SQL API)
  const uploadCategoryImageToFirebase = async (file: File) => {
    try {
      if (!companyId || !currentCategoryId) {
        throw new Error("Gerekli ID'ler bulunamadı.");
      }

      setImageUploading(true);
      
      // Firebase Storage'a yükle (resim depolama)
      const imageType = imageUploadType === 'header' ? 'headerImage' : 'image';
      const imagePath = `companies/${companyId}/ecommerce/categories/${currentCategoryId}/${imageType}`;
      const storageReference = storageRef(storage, imagePath);
      const uploadResult = await uploadBytes(storageReference, file);
      const downloadURL = await getDownloadURL(uploadResult.ref);

      // Kategori resmini güncelle
      const updatedCategory = config.menuCategories.find(cat => cat.id === currentCategoryId);
      if (updatedCategory) {
        const categoryData = {
          ...updatedCategory,
          companyId: companyId,
          configId: ecommerceConfigId,
          ...(imageUploadType === 'header' ? 
            { headerImageUrl: downloadURL } : 
            { imageUrl: downloadURL }
          )
        };
        
        // SQL API'ye kaydet
        await saveMenuCategory(categoryData);
        console.log('✅ [CATEGORY IMAGE] Kategori resmi SQL\'e kaydedildi');
      }

      // Config state'i güncelle
      const updatedCategories = config.menuCategories.map(category => {
        if (category.id === currentCategoryId) {
          return {
            ...category,
            ...(imageUploadType === 'header' ? 
              { headerImageUrl: downloadURL } : 
              { imageUrl: downloadURL }
            )
          };
        }
        return category;
      });

      setConfig(prev => ({
        ...prev,
        menuCategories: updatedCategories
      }));

      setCategoryImageModalOpen(false);
      setCurrentCategoryId(null);
      setImageUploadType('category');
    } catch (error) {
      console.error("Resim yükleme hatası:", error);
      setError("Resim yüklenirken bir hata oluştu.");
    } finally {
      setImageUploading(false);
    }
  };

  // Kategori genişletme/daraltma işlemi
  const toggleCategoryExpand = (categoryId: string) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  // Menü önizleme fonksiyonu
  const renderMenuPreview = () => {
    const menuType = config.menuSettings.menuType;
    const menuSettings = config.menuSettings;
    const categories = config.menuCategories;

    if (!menuSettings.enabled) {
      return (
        <Alert severity="info" sx={{ mt: 2 }}>
          Menü sistemi kapalı. Önizleme göstermek için menüyü aktif edin.
        </Alert>
      );
    }

    if (categories.length === 0) {
      return (
        <Alert severity="warning" sx={{ mt: 2 }}>
          Henüz kategori eklenmemiş. Kategorileri "Stok Yönetimi" sayfasından ekleyebilirsiniz.
        </Alert>
      );
    }

    const previewStyle = {
      border: '2px dashed #e0e0e0',
      borderRadius: '8px',
      padding: '16px',
      backgroundColor: '#fafafa',
      marginTop: '16px',
      minHeight: '120px'
    };

    const visibleCategories = categories.filter(cat => cat.visible).slice(0, 5); // İlk 5 kategori

    const renderMenu1Preview = () => (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        gap: 2, 
        backgroundColor: menuSettings.backgroundColor || '#ffffff',
        color: menuSettings.textColor || '#111827',
        borderRadius: 1,
        border: '1px solid #e0e0e0'
      }}>
        {/* Ana Menü Çubuğu */}
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          p: 2
        }}>
          {visibleCategories.map((category) => (
            <Box key={category.id} sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              px: 2,
              py: 1,
              borderRadius: 1,
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
              cursor: 'pointer',
              textTransform: menuSettings.textTransform || 'none'
            }}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {category.name}
              </Typography>
              <KeyboardArrowDownIcon sx={{ fontSize: 14, opacity: 0.7 }} />
            </Box>
          ))}
        </Box>
        
        <Typography variant="caption" sx={{ px: 2, pb: 1, color: 'text.secondary', fontStyle: 'italic' }}>
          💡 Kategorilere tıklandığında mega menü açılır
        </Typography>
      </Box>
    );

    const renderMenu2Preview = () => (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        gap: 2, 
        backgroundColor: menuSettings.backgroundColor || '#ffffff',
        color: menuSettings.textColor || '#111827',
        borderRadius: 1,
        border: '1px solid #e0e0e0'
      }}>
        {/* Ana Menü Çubuğu */}
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          p: 2
        }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            px: 2,
            py: 1,
            borderRadius: 1,
            backgroundColor: 'rgba(0,0,0,0.05)',
            textTransform: menuSettings.textTransform || 'none'
          }}>
            <MenuIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Tüm Kategoriler
            </Typography>
            <KeyboardArrowDownIcon sx={{ fontSize: 14, opacity: 0.7 }} />
          </Box>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            px: 2,
            py: 1,
            textTransform: menuSettings.textTransform || 'none'
          }}>
            <Typography variant="body2">Hakkımızda</Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            px: 2,
            py: 1,
            textTransform: menuSettings.textTransform || 'none'
          }}>
            <Typography variant="body2">İletişim</Typography>
          </Box>
        </Box>
        
        <Typography variant="caption" sx={{ px: 2, pb: 1, color: 'text.secondary', fontStyle: 'italic' }}>
          💡 "Tüm Kategoriler"e tıklandığında dropdown açılır
        </Typography>
      </Box>
    );

    const renderMenu3Preview = () => (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        gap: 2, 
        backgroundColor: menuSettings.backgroundColor || '#ffffff',
        color: menuSettings.textColor || '#111827',
        borderRadius: 1,
        border: '1px solid #e0e0e0'
      }}>
        {/* Ana Menü Çubuğu - Ortalanmış */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center',
          gap: 3, 
          p: 2,
          borderBottom: '1px solid #e0e0e0'
        }}>
          {/* Ana Sayfa Butonu - Koşullu */}
          {menuSettings.showHomePage !== false && (
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              px: 2,
              py: 1,
              textTransform: menuSettings.textTransform || 'none'
            }}>
              <HomeIcon sx={{ fontSize: 16 }} />
              <Typography variant="body2">Ana Sayfa</Typography>
            </Box>
          )}
          
          {/* Tüm Kategoriler Butonu - Koşullu */}
          {menuSettings.showAllCategories !== false && (
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              px: 3,
              py: 1.5,
              borderRadius: 2,
              backgroundColor: 'rgba(0,0,0,0.05)',
              textTransform: menuSettings.textTransform || 'none'
            }}>
              <Grid3X3Icon sx={{ fontSize: 18 }} />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Tüm Kategoriler
              </Typography>
              <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
            </Box>
          )}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            px: 2,
            py: 1,
            textTransform: menuSettings.textTransform || 'none'
          }}>
            <VisibilityIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2">Kurumsal</Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            px: 2,
            py: 1,
            textTransform: menuSettings.textTransform || 'none'
          }}>
            <SettingsIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2">Hizmetlerimiz</Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            px: 2,
            py: 1,
            textTransform: menuSettings.textTransform || 'none'
          }}>
            <BusinessIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2">Referanslar</Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            px: 2,
            py: 1,
            textTransform: menuSettings.textTransform || 'none'
          }}>
            <StorefrontIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2">Ürün & Çözümler</Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            px: 2,
            py: 1,
            textTransform: menuSettings.textTransform || 'none'
          }}>
            <ContactMailOutlinedIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2">İletişim</Typography>
          </Box>
          {menuSettings.showQuoteButton === true && (
            <Box
              sx={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.75,
                width: 106,
                minHeight: 152,
                px: 1,
                py: 2,
                borderTopLeftRadius: 16,
                borderBottomLeftRadius: 16,
                border: '1px solid #d1d5db',
                backgroundColor: '#f3f4f6',
                color: '#1f2937',
                boxShadow: 2,
              }}
            >
              <DescriptionIcon sx={{ fontSize: 16 }} />
              <Typography variant="caption" sx={{ fontSize: '0.6875rem', fontWeight: 700, textAlign: 'center', lineHeight: 1.25 }}>
                {menuSettings.quoteButtonSubtitle || 'Teklif formunu doldurmak için tıklayın'}
              </Typography>
            </Box>
          )}
        </Box>
        

        
        <Typography variant="caption" sx={{ px: 2, pb: 1, color: 'text.secondary', fontStyle: 'italic' }}>
          💡 Modern tasarım ile ortalanmış menü. "Tüm Kategoriler", "Ana Sayfa" ve "Teklif Al" butonları ayarlanabilir.
        </Typography>
      </Box>
    );

    try {
      switch (menuType) {
        case 'menu1':
          return (
            <Box sx={previewStyle}>
              <Typography variant="subtitle2" gutterBottom sx={{ color: 'text.secondary', mb: 2, display: 'flex', alignItems: 'center' }}>
                <ViewCarouselIcon sx={{ mr: 1, fontSize: 18 }} />
                Menü 1 Önizlemesi (Standart Mega Menü)
              </Typography>
              {renderMenu1Preview()}
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                Bu menü kategorileri yatay listeler. Her kategoriye tıklandığında mega menü açılır.
              </Typography>
            </Box>
          );
        case 'menu2':
          return (
            <Box sx={previewStyle}>
              <Typography variant="subtitle2" gutterBottom sx={{ color: 'text.secondary', mb: 2, display: 'flex', alignItems: 'center' }}>
                <MenuIcon sx={{ mr: 1, fontSize: 18 }} />
                Menü 2 Önizlemesi (Kompakt Menü)
              </Typography>
              {renderMenu2Preview()}
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                Bu menü kompakt tasarım sunar. "Tüm Kategoriler" dropdown'unda kategoriler listelenir.
              </Typography>
            </Box>
          );
        case 'menu3':
          return (
            <Box sx={previewStyle}>
              <Typography variant="subtitle2" gutterBottom sx={{ color: 'text.secondary', mb: 2, display: 'flex', alignItems: 'center' }}>
                <StorefrontIcon sx={{ mr: 1, fontSize: 18 }} />
                Menü 3 Önizlemesi (Modern Dropdown Menü)
              </Typography>
              {renderMenu3Preview()}
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                Bu menü modern tasarım ile ortalanmış düzen sunar. "Tüm Kategoriler" ve "Ana Sayfa" butonları ayarlanabilir.
              </Typography>
            </Box>
          );
        default:
          return (
            <Alert severity="info" sx={{ mt: 2 }}>
              Menü tipi seçilmemiş.
            </Alert>
          );
      }
    } catch (error) {
      return (
        <Alert severity="error" sx={{ mt: 2 }}>
          Menü önizlemesi yüklenirken hata oluştu. Lütfen kategorilerinizi kontrol edin.
        </Alert>
      );
    }
  };

  // Kategori öğelerini render eden fonksiyon
  const renderCategoryItems = (categories: MenuCategory[], level: number = 0, parentCategories?: MenuCategory[]): React.ReactNode => {
    if (!categories || categories.length === 0) return null;
    
    // Sıralanmış kategoriler
    return categories
      .sort((a, b) => a.order - b.order)
      .map((category, index, sortedArray) => {
        // Alt kategorileri var mı?
        const hasSubCategories = category.subCategories && category.subCategories.length > 0;
        
        // Genişletilmiş mi?
        const isExpanded = expandedCategories[category.id] || false;
        
        return (
          <React.Fragment key={category.id}>
            <ListItem
              sx={{
                bgcolor: category.visible ? 'transparent' : 'rgba(0,0,0,0.04)',
                opacity: category.visible ? 1 : 0.7,
                pl: level * 3 + 2 // Seviyeye göre girinti
              }}
            >
              {/* Genişletme/daraltma ikonu */}
              {hasSubCategories ? (
                <IconButton
                  size="small"
                  onClick={() => toggleCategoryExpand(category.id)}
                  sx={{ mr: 1, p: 0.5 }}
                >
                  {isExpanded ? 
                    <KeyboardArrowDownIcon fontSize="small" /> : 
                    <KeyboardArrowRightIcon fontSize="small" />
                  }
                </IconButton>
              ) : (
                <Box sx={{ width: 28, height: 28, mr: 1 }} /> // Boşluk bırak
              )}
              
              <ListItemIcon>
                {category.imageUrl ? (
                  <Avatar 
                    src={category.imageUrl} 
                    alt={category.name}
                    sx={{
                      width: 40,
                      height: 40,
                      cursor: level === 0 ? 'pointer' : 'default',
                      border: '1px solid #eee'
                    }}
                    onClick={level === 0 ? () => handleCategoryImageButtonClick(category.id) : undefined}
                  />
                ) : (
                  <StorefrontIcon color={category.visible ? "primary" : "disabled"} />
                )}
              </ListItemIcon>
              <ListItemText 
                primary={category.name} 
                primaryTypographyProps={{
                  fontWeight: category.visible ? 'medium' : 'normal',
                  color: category.visible ? 'text.primary' : 'text.secondary'
                }}
              />
              <ListItemSecondaryAction>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {/* Sadece ana kategorilerde resim yükleme butonları göster */}
                  {level === 0 && (
                    <>
                      <Tooltip title={category.imageUrl ? "Kategori Resmini Değiştir" : "Kategori Resmi Ekle"}>
                        <IconButton
                          edge="end"
                          onClick={() => handleCategoryImageButtonClick(category.id)}
                          size="small"
                          disabled={imageUploading && currentCategoryId === category.id}
                        >
                          {imageUploading && currentCategoryId === category.id ? (
                            <CircularProgress size={16} />
                          ) : (
                            <ImageIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={category.headerImageUrl ? "Sayfa Üst Resmini Değiştir" : "Sayfa Üst Resmi Ekle"}>
                        <IconButton
                          edge="end"
                          onClick={() => handleCategoryHeaderImageButtonClick(category.id)}
                          size="small"
                          disabled={imageUploading && currentCategoryId === category.id}
                          sx={{ color: category.headerImageUrl ? 'success.main' : 'text.secondary' }}
                        >
                          {imageUploading && currentCategoryId === category.id ? (
                            <CircularProgress size={16} />
                          ) : (
                            <ViewCarouselIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  <Tooltip title={category.visible ? "Gizle" : "Göster"}>
                    <IconButton 
                      edge="end" 
                      onClick={() => toggleCategoryVisibility(category.id)}
                      size="small"
                    >
                      {category.visible ? 
                        <VisibilityIcon fontSize="small" /> : 
                        <VisibilityOffIcon fontSize="small" />
                      }
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Yukarı Taşı">
                    <IconButton 
                      edge="end" 
                      onClick={() => moveCategoryUp(index, parentCategories || sortedArray)}
                      disabled={index === 0}
                      size="small"
                    >
                      <ArrowUpwardIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Aşağı Taşı">
                    <IconButton 
                      edge="end" 
                      onClick={() => moveCategoryDown(index, parentCategories || sortedArray)}
                      disabled={index === sortedArray.length - 1}
                      size="small"
                    >
                      <ArrowDownwardIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </ListItemSecondaryAction>
            </ListItem>
            
            {/* Alt kategorileri göster */}
            {isExpanded && hasSubCategories && category.subCategories && renderCategoryItems(category.subCategories, level + 1, sortedArray)}
          </React.Fragment>
        );
      });
  };

  const handleFaviconFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file.size > 1 * 1024 * 1024) { // 1MB limit
        setError("Favicon boyutu 1MB'dan büyük olamaz.");
        return;
      }
      setFaviconFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setFaviconPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFaviconUpload = async () => {
    if (!faviconFile || !companyId) {
      setError("Lütfen bir favicon dosyası seçin.");
      return;
    }
    
    setIsUploadingFavicon(true);
    setError(null);
  
    try {
      // 1. Firebase Storage'a yükle
      const faviconPath = `companies/${companyId}/favicon/${Date.now()}_${faviconFile.name}`;
      const faviconStorageReference = storageRef(storage, faviconPath);
      await uploadBytes(faviconStorageReference, faviconFile);
      const downloadURL = await getDownloadURL(faviconStorageReference);
      
      console.log('✅ [FAVICON] Firebase Storage yükleme başarılı:', downloadURL);
      
      // 2. SQL'e kaydet
      const response = await saveGeneralConfig({
        companyId: companyId,
        faviconUrl: downloadURL
      });
      
      if (response.success) {
        console.log('✅ [FAVICON] SQL kayıt başarılı');
        setCurrentFaviconUrl(downloadURL);
      setFaviconFile(null);
      setFaviconPreview(null);
      }
  
    } catch (err: any) {
      console.error("❌ [FAVICON] Yükleme hatası:", err);
      setError(err.message || "Favicon yüklenirken bir hata oluştu.");
    } finally {
      setIsUploadingFavicon(false);
    }
  };

  // Site Background Settings Handler
  const handleSiteBackgroundChange = async (field: string, value: any) => {
    console.log('🎨 [BACKGROUND] Değişiklik:', field, value);
    
    setSiteBackgroundSettings((prev: any) => ({
      ...prev,
      [field]: value
    }));

    // Auto-save to SQL
    try {
      if (!companyId || !ecommerceConfigId) {
        console.warn('⚠️ [BACKGROUND] CompanyId veya ConfigId yok, kayıt yapılamıyor');
        return;
      }

      const backgroundData = {
        companyId: companyId,
        id: backgroundConfigId,
        configId: ecommerceConfigId,
        backgroundType: field === 'type' ? value : (siteBackgroundSettings.type || 'color'),
        backgroundColor: field === 'backgroundColor' ? value : (siteBackgroundSettings.backgroundColor || '#ffffff'),
        patternType: field === 'patternType' ? value : siteBackgroundSettings.patternType,
        isActive: true
      };

      console.log('💾 [BACKGROUND] SQL e kaydediliyor:', backgroundData);
      
      const response = await saveSiteBackground(backgroundData);
      
      if (response.success) {
        console.log('✅ [BACKGROUND] SQL kayıt başarılı');
        notifyEcommerceSaved(t('ecommerceGeneral.autoSave.savedToast'));
        if (!backgroundConfigId && response.data?.id) {
          setBackgroundConfigId(response.data.id);
        }
      }
    } catch (error) {
      console.error('❌ [BACKGROUND] Kayıt hatası:', error);
    }
  };

  return (
    <ScrollableContent>
      <EcommerceSaveToastHost />
      <HeaderContainer>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <StoreIcon sx={{ fontSize: 32, mr: 1.5, color: 'primary.main' }} />
          <Typography variant="h5" component="h1" fontWeight="bold">
            {t('ecommercePage.title')}
          </Typography>
          <GuideButton guideKey="ecommerce.page" size="small" sx={{ ml: 1 }} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <FormControlLabel
            sx={{ ml: 2, mr: 0 }}
            control={
              <Switch
                checked={siteWizardEnabled}
                onChange={handleSiteWizardToggle}
                color="primary"
              />
            }
            label={t('ecommerceNav.wizardToggle')}
            title={t('ecommerceNav.wizardHint')}
          />
          {showNavModeToggle && (
            <FormControlLabel
              sx={{ ml: 1, mr: 0 }}
              control={
                <Switch
                  checked={navMode === 'classic'}
                  onChange={handleNavModeChange}
                  color="primary"
                />
              }
              label={t('ecommerceNav.normalToggle')}
              title={t('ecommerceNav.normalHint')}
            />
          )}
        </Box>
      </HeaderContainer>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Paper sx={{ mb: 3 }}>
            <EcommerceTabNavigation
              activeTabId={activeTabId}
              onTabChange={setActiveTabId}
              mode={showNavModeToggle ? navMode : 'classic'}
              showWizard={siteWizardEnabled}
              badges={{ liveChat: chatAlerts }}
            />
          </Paper>

          {siteWizardEnabled && activeTabId === 'site-wizard' && (
            <SiteSetupWizard
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
              onNavigate={setActiveTabId}
            />
          )}

          {(activeTabId === 'general-settings' || activeTabId === 'corporate-nav') && (
            <GeneralSettings
              companyId={companyId}
              siteBackgroundSettings={siteBackgroundSettings}
              onConfigChange={handleSiteBackgroundChange}
              initialTab={activeTabId === 'corporate-nav' ? 2 : 0}
              corporateNavDisplayMode={config.menuSettings.corporateNavDisplayMode}
              corporateSidebarLayoutMode={config.menuSettings.corporateSidebarLayoutMode}
              corporateSidebarSettings={config.menuSettings.corporateSidebarSettings}
              onMenuSettingChange={handleMenuSettingChange}
            />
          )}

          {activeTabId === 'languages' && (
            <LanguageSettings companyId={companyId} />
          )}

          {activeTabId === 'members' && (
            <MembersManagement companyId={companyId} />
          )}

          {activeTabId === 'guest-checkout' && (
            <GuestCheckoutSettings
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {activeTabId === 'b2b' && (
            <B2BManagement companyId={companyId} />
          )}

          {activeTabId === 'payment-settings' && (
            <MokaPaymentSettings companyId={companyId} />
          )}

          {activeTabId === 'returns' && (
            <ReturnsManagement companyId={companyId} />
          )}

          {activeTabId === 'campaigns' && (
            <CampaignManagement companyId={companyId} configId={ecommerceConfigId || config.id || ''} />
          )}

          {activeTabId === 'promo-cards' && companyId && (
            <MarketingPromoCards
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {activeTabId === 'showcase-areas' && companyId && (
            <ShowcaseAreasManagement
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {activeTabId === 'orders' && (
            <OrdersManagement companyId={companyId} />
          )}

          {activeTabId === 'questions' && (
            <ProductQuestionsManagement companyId={companyId} />
          )}

          {activeTabId === 'header' && (
            <HeaderSettings
              config={config}
              defaultConfig={defaultConfig}
              currentLogoUrl={currentLogoUrl}
              onHeaderSettingChange={handleHeaderSettingChange}
              onOpenLogoLibrary={handleOpenLogoLibrary}
              onOpenIconModal={handleOpenIconModal}
              onRemoveLogo={handleRemoveLogo}
              configId={ecommerceConfigId || config.id || ''}
              companyId={companyId || ''}
              onNavigate={setActiveTabId}
            />
          )}

          {/* Ana Sayfa Ayarları */}
          {activeTabId === 'homepage' && companyId && (
            <HomePageSettings 
              companyId={companyId} 
              configId={ecommerceConfigId || config.id || ''}
              config={config}
              onMenuSettingChange={handleMenuSettingChange}
            />
          )}

          {/* Menü Ayarları */}
          {activeTabId === 'menus' && (
            <MenuSettings
              config={config}
              defaultConfig={defaultConfig}
              mainMenuCategories={mainMenuCategories}
              subMenuCategories={subMenuCategories}
              isMenuForcedDisabled={!getHeaderTemplate(config.headerSettings?.headerType).capabilities.separateMenu}
              onMenuSettingChange={handleMenuSettingChange}
              onHeaderSettingChange={handleHeaderSettingChange}
              onOpenMenuLogoLibrary={handleOpenMenuLogoLibrary}
              onRemoveMenuLogo={handleRemoveMenuLogo}
              onOpenCategoryImageLibrary={handleOpenCategoryImageModal}
              onUpdateCategoryImage={handleOpenCategoryImageModal}
              onViewCategoryImage={handleViewCategoryImage}
              onRemoveCategoryImage={handleRemoveCategoryImageRequest}
              onToggleCategoryVisibility={handleToggleCategoryVisibility}
              onMoveCategoryUp={handleMoveCategoryUp}
              onMoveCategoryDown={handleMoveCategoryDown}
              onNavigate={setActiveTabId}
            />
          )}

          {/* Slider Ayarları */}
          {activeTabId === 'slider' && (
            <SliderSettingsComponent 
              settings={config.sliderSettings}
              onSettingsChange={handleSliderSettingChange}
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''} // ✅ SQL için configId eklendi
            />
          )}

          {/* Kategori Ayarları - menuCategories SQL'den geliyor */}
          {activeTabId === 'categories' && (
            ecommerceConfigId ? (
              <CategorySettingsComponent
                settings={config.categorySettings}
                onSettingsChange={handleCategorySettingChange}
                menuCategories={sqlMenuCategories}
                companyId={companyId}
                configId={ecommerceConfigId}
              />
            ) : (
              <Alert severity="info">Kategori ayarları yükleniyor...</Alert>
            )
          )}

          {activeTabId === 'brands' && (
            <BrandManagement companyId={companyId} />
          )}

          {/* Ürün Ayarları */}
          {activeTabId === 'products' && (
            <ProductSettingsComponent
              settings={{
                productSettings: config.productSettings,
                productDisplaySettings: config.productDisplaySettings,
              }}
              onSettingsChange={{
                product: handleProductSettingChange,
                display: handleProductDisplaySettingChange,
              }}
              companyId={companyId || ''}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {/* Ürün Detay Ayarları */}
          {activeTabId === 'product-detail' && (
            <ProductDetailSettings
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {/* Tacreo Ürün Detay Ayarları */}
          {activeTabId === 'product-detail-tacreo' && (
            <ProductDetailSettings2
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {/* Footer Ayarları */}
          {activeTabId === 'footer' && (
            <FooterSettingsComponent
              settings={config.footerSettings}
              onSettingsChange={handleFooterSettingChange}
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
              onNavigate={setActiveTabId}
            />
          )}

          {/* Sepet Ayarları */}
          {activeTabId === 'login-page' && (
            <LoginPageSettings
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
              siteName={config.siteName || ''}
            />
          )}

          {activeTabId === 'cart' && (
            <CartSettingsComponent
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
              onNavigate={setActiveTabId}
            />
          )}

          {/* Sayfalar Ayarları */}
          {activeTabId === 'pages' && companyId && (
            <PagesSettings
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {activeTabId === 'cards' && companyId && (
            <ContentCardsSettings
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {/* Formlar Ayarları */}
          {activeTabId === 'forms' && companyId && (
            <FormsSettings
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {/* Yasal Sözleşmeler */}
          {activeTabId === 'legal' && companyId && (
            <LegalDocumentsSettings
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
              companyName={config.siteName || ''}
            />
          )}

          {/* Hakkımızda Ayarları */}
          {activeTabId === 'about' && (
            <AboutSettingsComponent 
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''} // ✅ SQL için configId eklendi
              onSettingsChange={handleAboutSettingsChange}
            />
          )}

          {/* Hizmetler Ayarları */}
          {activeTabId === 'services' && (
            <ServiceSettingsComponent 
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
              onSettingsChange={handleServiceSettingsChange}
            />
          )}

          {/* İletişim Ayarları */}
          {activeTabId === 'contact' && (
            <ContactSettingsComponent 
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''} // ✅ SQL için configId eklendi
              onSettingsChange={handleContactSettingsChange}
            />
          )}

          {/* Şubeler Ayarları */}
          {activeTabId === 'branches' && (
            <BranchSettingsComponent
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
              onSettingsChange={handleRestaurantSettingsChange}
            />
          )}

          {/* Referanslar Ayarları */}
          {activeTabId === 'references' && (
            <ReferencesSettingsComponent 
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''} // ✅ SQL için configId eklendi
              settings={config.referencesSettings}
              onSettingsChange={handleReferencesSettingsChange}
            />
          )}

          {/* Blog Ayarları */}
          {activeTabId === 'blog' && (
            <BlogSettingsComponent 
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {/* FAQ Ayarları */}
          {activeTabId === 'faq' && (
            <FAQSettingsComponent 
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
            />
          )}

          {/* Yorum Yönetimi */}
          {activeTabId === 'reviews' && (
            <ReviewsManagement companyId={companyId} />
          )}

          {/* Destek Talepleri */}
          {activeTabId === 'support' && (
            <SupportManagement companyId={companyId} />
          )}

          {activeTabId === 'liveChat' && (
            <LiveChatManagement companyId={companyId} focus={liveChatFocus} />
          )}

          {/* Ürün & Çözümler Ayarları */}
          {activeTabId === 'product-solutions' && (
            <ProductSolutionSettingsComponent 
              companyId={companyId}
              configId={ecommerceConfigId || config.id || ''}
              settings={config.productSolutionSettings}
              onSettingsChange={handleProductSolutionSettingsChange}
            />
          )}
        </>
      )}

      {/* Kategori Resim Yükleme Modal'ı */}
      <CategoryImageModal
        open={categoryImageModalOpen}
        onClose={() => {
          setCategoryImageModalOpen(false);
          setImageUploadType('category');
        }}
        onUpload={uploadCategoryImageToFirebase}
        loading={imageUploading}
        title={imageUploadType === 'header'
          ? t('ecommerceCategoryImageModal.headerTitle')
          : t('ecommerceCategoryImageModal.categoryTitle')}
        description={imageUploadType === 'header'
          ? t('ecommerceCategoryImageModal.headerDescription')
          : t('ecommerceCategoryImageModal.categoryDescription')}
      />

      {/* Logo Resim Kütüphanesi Modalı */}
      <ImageLibrarySelectionModal
        open={isLogoLibraryModalOpen}
        onClose={handleCloseLogoLibrary}
        onSave={handleSaveLogoFromLibrary}
        productId={null}
        productName={logoType === 'desktop'
          ? t('ecommerceImageLibraryNames.desktopLogo')
          : logoType === 'mobile'
            ? t('ecommerceImageLibraryNames.mobileLogo')
            : t('ecommerceImageLibraryNames.menuLeftLogo')}
        currentImageUrls={
          logoType === 'mobile'
            ? (config.headerSettings.mobileLogoUrl ? [config.headerSettings.mobileLogoUrl] : [])
            : (config.headerSettings.logoUrl ? [config.headerSettings.logoUrl] : [])
        }
        companyId={companyId}
      />

      {/* İkon Seçimi Modalı */}
      <IconSelectionModal
        open={isIconModalOpen}
        onClose={handleCloseIconModal}
        onSave={handleSaveIcon}
        currentIcon={config.headerSettings.header4Cards?.[iconModalCardType]?.iconUrl || (iconModalCategory === 'phone' ? 'phone' : 'cart')}
        iconCategory={iconModalCategory}
      />

      {/* Kategori Resim Kütüphanesi Modalı */}
      <ImageLibrarySelectionModal
        open={isCategoryImageModalOpen}
        onClose={handleCloseCategoryImageModal}
        onSave={handleSaveCategoryImage}
        productId={null}
        singleSelect
        productName={selectedCategoryForImage 
          ? `${sqlMenuCategories.find(c => c.categoryId === selectedCategoryForImage.categoryId)?.categoryName || t('ecommerceImageLibraryNames.category')} - ${selectedCategoryForImage.imageType === 'category' ? t('ecommerceImageLibraryNames.categoryImage') : t('ecommerceImageLibraryNames.bannerImage')}`
          : t('ecommerceImageLibraryNames.categoryImage')
        }
        currentImageUrls={selectedCategoryForImage
          ? (() => {
              const category = sqlMenuCategories.find(c => c.categoryId === selectedCategoryForImage.categoryId);
              const imageUrl = selectedCategoryForImage.imageType === 'category' 
                ? category?.categoryImageUrl 
                : category?.bannerImageUrl;
              return imageUrl ? [imageUrl] : [];
            })()
          : []
        }
        companyId={companyId}
      />

      {/* Kategori Resmi Büyük Görüntüleme Modalı */}
      <ImageViewModal
        open={Boolean(categoryImageView)}
        onClose={() => setCategoryImageView(null)}
        imageUrls={categoryImageView ? [categoryImageView.url] : []}
        itemName={categoryImageView?.name || ''}
      />

      {/* Kategori Resmi Kaldırma Onayı */}
      <ConfirmDialog
        open={Boolean(categoryImageRemoveTarget)}
        onClose={() => setCategoryImageRemoveTarget(null)}
        onConfirm={confirmRemoveCategoryImage}
        title={t('ecommerceMenuSettings.actions.removeImage')}
        content={t('ecommerceMenuSettings.removeImageConfirm', { name: categoryImageRemoveTarget?.name || '' })}
        confirmButtonText={t('ecommerceMenuSettings.actions.removeImage')}
        isLoading={isRemovingCategoryImage}
      />
    </ScrollableContent>
  );
};

export default ECommercePage; 